export const ru: Resources = {
  translation: {
    common: {
      appName: "GUDWIN",
      loading: "Загрузка…",
      error: "Ошибка",
      apiError: {
        fallback: "Произошла ошибка. Обратитесь к системному администратору.",
        requestId: "Идентификатор запроса: {{id}}",
      },
      retry: "Повторить",
      save: "Сохранить",
      cancel: "Отмена",
      delete: "Удалить",
      confirm: "Подтвердить",
      close: "Закрыть",
      clear: "Очистить",
      back: "Назад",
      notFound: "Страница не найдена",
      elementLabel: "Элемент: {{name}}",
      statusToggle: {
        on: "АКТИВЕН",
        off: "ВЫКЛ",
      },
      combobox: {
        searchPlaceholder: "Поиск…",
        empty: "Ничего не найдено",
      },
      multiSelect: {
        selectAll: "Выбрать всё",
        clearAll: "Снять всё",
        selected: "Выбрано: {{selected}} из {{total}}",
      },
      dateField: {
        placeholder: "Выберите дату",
        previousMonth: "Предыдущий месяц",
        nextMonth: "Следующий месяц",
        clear: "Очистить дату",
        weekdays: {
          mon: "Пн",
          tue: "Вт",
          wed: "Ср",
          thu: "Чт",
          fri: "Пт",
          sat: "Сб",
          sun: "Вс",
        },
      },
      workTypeSet: {
        addCta: "Добавить работу",
        searchPlaceholder: "Поиск вида работы…",
        searchEmpty: "Ничего не найдено",
        empty: "Работ пока нет.",
        remove: "Убрать «{{name}}»",
        removeConfirmTitle: "Убрать вид работы?",
        removeConfirmBody: "Вид работы «{{name}}» будет убран из набора без возможности отмены.",
      },
      passwordInput: {
        show: "Показать пароль",
        hide: "Скрыть пароль",
      },
      // Слово встраивается в фразу («сегодня, 09:14»), поэтому со строчной —
      // отдельно от самостоятельных лейблов «Сегодня» на других экранах.
      relativeTime: {
        today: "сегодня",
      },
      releaseUpdate: {
        available: "Доступно обновление",
        action: "Обновить",
      },
    },
    validation: {
      required: "Заполните поле",
      invalidType: "Неверное значение",
      invalidValue: "Недопустимое значение",
      invalidFormat: "Неверный формат",
      notMultipleOf: "Недопустимое значение",
      tooShort: "Минимум {{min}} символов",
      tooLong: "Не более {{max}} символов",
      numberTooSmall: "Не меньше {{min}}",
      numberTooBig: "Не больше {{max}}",
      tooSmall: "Слишком мало (минимум {{min}})",
      tooBig: "Слишком много (максимум {{max}})",
      endBeforeStart: "Дата окончания не может быть раньше начала",
      emailInvalid: "Введите корректный адрес электронной почты",
      emailReservedDomain: "Этот домен электронной почты зарезервирован. Укажите другой адрес",
      fieldErrorCount_one: "Исправьте {{count}} поле",
      fieldErrorCount_few: "Исправьте {{count}} поля",
      fieldErrorCount_many: "Исправьте {{count}} полей",
      fieldErrorCount_other: "Исправьте {{count}} поля",
    },
    errorBoundary: {
      eyebrow: "Сбой",
      title: "Что-то пошло не так",
      body: "Страница не смогла отрисоваться. Запрос уже зафиксирован в журнале — передайте администратору идентификатор ниже.",
      requestIdLabel: "Идентификатор запроса",
      requestIdHint: "Скопируйте идентификатор и пришлите администратору для разбора.",
      noRequestId: "Идентификатор запроса недоступен — это локальный сбой интерфейса.",
      copy: "Копировать",
      copied: "Идентификатор скопирован",
      copyFailed: "Не удалось скопировать",
      reload: "Перезагрузить",
    },
    nav: {
      breadcrumb: "Хлебные крошки",
      home: "Главная",
      projects: "Проекты",
      approvals: "Симуляции",
      risks: "Риски",
      portfolio: "Портфель",
      load: "Загрузка ресурсов",
      units: "Отделы и подразделения",
      people: "Сотрудники",
      new: "Новый сотрудник",
      templates: "Шаблоны",
      audit: "Аудит",
      calendar: "Производственный календарь",
      settings: "Настройки",
      "change-password": "Смена пароля",
      admin: "Администрирование",
      users: "Сотрудники",
      catalogs: "Справочники",
      "time-approval": "Учёт времени",
      "work-status": "Статусы работ",
      login: "Вход в систему",
      collapse: "Свернуть",
      expand: "Развернуть",
      approvalDetail: "Симуляция",
      section: {
        myWork: "Моя работа",
        decisions: "Решения",
        reference: "Настройка",
      },
    },
    peopleHub: {
      title: "Сотрудники",
      tabs: {
        employees: "Сотрудники",
        structure: "Оргструктура",
        availability: "График отсутствий и переработок",
      },
    },
    peopleCard: {
      readOnly: "Карточка доступна только для просмотра",
    },
    workStatus: {
      title: "Статусы работ",
      pickUnit: "Выберите подразделение, чтобы увидеть работы",
      empty:
        "В подразделении пока нет работ — они появляются, когда сотрудники отчитываются о времени",
      emptySearch: "Ничего не найдено",
      search: {
        aria: "Поиск по работам",
        placeholder: "Сотрудник, работа или проект",
      },
      filters: {
        reset: "Сбросить",
      },
      updated: {
        actualized: "Руководитель актуализировал: {{at}}",
        tracked: "Работу ещё не актуализировали. Последний учтённый день: {{at}}",
      },
      columns: {
        work: "Работа",
        performer: "Исполнитель",
        status: "Статус",
        forecast: "Прогноз",
        dueDate: "Срок",
        checkpoints: "Контрольные точки",
        updated: "Обновлено",
      },
      status: {
        planned: "В плане",
        in_progress: "В работе",
        paused: "Пауза",
        completed: "Завершена",
      },
      forecast: {
        gt2w: "> 2 нед",
        w2: "2 нед",
        w1: "1 нед",
        d3: "3 дня",
        d1: "1 день",
      },
      checkpoints: {
        done: "{{title}} — выполнена",
        open: "{{title}} — не выполнена",
      },
      overdueBadge_one: "Просрочена на {{count}} день",
      overdueBadge_few: "Просрочена на {{count}} дня",
      overdueBadge_many: "Просрочена на {{count}} дней",
      overdueBadge_other: "Просрочена на {{count}} дней",
      panel: {
        status: "Статус",
        forecast: "Прогноз",
        completedAt: "Дата завершения",
        dueDate: "Срок",
        dueDateEmpty: "Срок не задан — нажмите, чтобы поставить",
        completedAtHint: "Часы, учтённые после этой даты, считаются доработкой.",
        checkpoints: "Контрольные точки",
        noCheckpoints: "У этой работы контрольных точек нет",
        addCheckpoint: "Добавить контрольную точку",
        addCheckpointPlaceholder: "Новая контрольная точка",
        removeCheckpoint: "Удалить контрольную точку",
        removeCheckpointConfirmTitle: "Удалить контрольную точку?",
        removeCheckpointConfirmBody:
          "Контрольная точка «{{title}}» будет удалена из этой работы вместе с отметкой о выполнении. Запись об удалении останется в истории.",
        comment: "Комментарий",
        commentPlaceholder: "Заметка к изменению — уйдёт в журнал вместе с датой и автором",
        history: "История",
        noHistory: "Изменений пока не было",
        noPerformer: "Исполнитель не определён",
        updatedAt: "обновлено {{when}}",
        event: {
          status: "Статус: {{from}} → {{to}}",
          forecast: "Прогноз: {{from}} → {{to}}",
          completedAt: "Дата завершения: {{from}} → {{to}}",
          dueDate: "Срок: {{from}} → {{to}}",
          memoQuote: "«{{memo}}»",
          checkpoint: {
            done: "Контрольная точка «{{title}}» выполнена",
            pending: "С контрольной точки «{{title}}» снята отметка",
            added: "Добавлена контрольная точка «{{title}}»",
            removed: "Удалена контрольная точка «{{title}}»",
          },
        },
      },
    },
    timeApproval: {
      title: "Учёт времени",
      subtitle:
        "Сданные отчёты участка — на проверку и подтверждение; внесение и правка за сотрудника",
      selfSubtitle: "Внесите и подпишите своё рабочее время",
      tabs: {
        console: "Подтверждение",
        entry: "Заполнить время",
        history: "История",
      },
      entryTab: {
        dateLabel: "Дата",
        selfHint: "Я · руководитель",
        selfSubjectLabel: "Ваше рабочее время",
        empty: "Выберите сотрудника и дату, чтобы внести или поправить время",
      },
      week: "Неделя",
      prevWeek: "Предыдущая неделя",
      nextWeek: "Следующая неделя",
      thisWeek: "Текущая неделя",
      legendTitle: "Легенда",
      legendPending: "На подтверждении — ждут вашего решения",
      legendMissing: "Не сдали — отчёта ещё нет",
      legendDone: "Разобрано — день закрыт",
      ctxPending: "На подтверждении: {{count}}",
      ctxMissing: "Не сдали: {{count}}",
      ctxApproved: "Подтверждено: {{count}}",
      chipDoneAria: "Всё разобрано",
      chipNoDataAria: "Нет данных",
      noUnit: "За вами не закреплено подразделение",
      loadError: "Не удалось загрузить сводку недели",
      feedHeader: "Сданы · {{submitted}}",
      feedEmpty: "За этот день сданных отчётов нет",
      you: "ВЫ",
      badgeWaiting: "на подтв.",
      discTitle: "Расхождение",
      discOverNorm: "Табель больше нормы смены",
      discUnderNorm: "Табель меньше нормы смены",
      discAbsence: "Работал в день отсутствия: {{name}}",
      markBadge: "отсутствует",
      markReason: "Причина",
      badgeApproved: "подтв.",
      footNorm: "Норма",
      footTasks: "Всего работ",
      footDeclaredVsNorm: "Табель vs норма",
      elementMissing: {
        title: "Элемент не выбран",
        body: "Сотрудник не указал элемент. Уточните и дополните отчёт при необходимости.",
      },
      edit: "Править",
      openDay: "Открыть день · {{name}}",
      approve: "Подтвердить",
      cancelApproval: "Отменить",
      approving: "Подтверждаю…",
      compactDeclared: "Табель",
      compactTasks: "Работ",
      approveError: "Не удалось подтвердить отчёт",
      cancelError: "Не удалось отменить подтверждение",
      missingTitle: "Не сдали · {{count}}",
      missingExpand: "Разобрать несдавших",
      missingCollapse: "Свернуть",
      missingHint: "должны были по графику · не в отпуске / отгуле",
      missingEmpty: "Все по графику отчитались",
      missingBadge: "не сдан",
      enter: "Внести",
      absence: "Отсутствие",
      dockEnterTitle: "Внести за сотрудника",
      dockEditTitle: "Правка отчёта",
      dockSelfEnterTitle: "Ввод рабочего времени",
      dockSelfEditTitle: "Правка рабочего времени",
      dockEnteredByLead: "отчёта не было · вносит руководитель",
      dockEditClarify: "Уточнение отчёта сотрудника",
      dockSubject: "Сотрудник · день",
      dockDeclared: "Табельное, ч",
      dockRecords: "Работы и задачи",
      dockNoRecords: "— записей нет —",
      dockAddRecord: "Добавить работу",
      dockEditRecord: "Изменить запись",
      dockConfirm: "Подтвердить",
      dockSign: "Подписать",
      dockSaving: "Сохраняю…",
      composerProject: "Проект",
      composerWorkType: "Работа",
      composerHours: "Часы",
      composerFreeWorkType: "Свободный ввод",
      composerAdd: "Добавить",
      composerCancel: "Отмена",
      absenceTitle: "Отметить отсутствие",
      absenceReasonLabel: "Причина",
      absenceReasonNoShow: "Невыход",
      absenceReasonSick: "Больничный",
      absenceReasonDayOff: "Отгул",
      absenceReasonOther: "За свой счёт",
      absenceNote: "Комментарий",
      absenceSave: "Отметить отсутствие",
      absenceSaved: "Отсутствие отмечено",
      absenceError: "Не удалось отметить отсутствие",
      enteredOk: "Отчёт внесён и подтверждён",
      signedOk: "Отчёт подписан",
      enterError: "Не удалось внести отчёт",
      entryDeleted: "Запись удалена",
      entryDeleteError: "Не удалось удалить запись",
      entryDeleteTitle: "Удалить запись времени?",
      entryDeleteBody: "Запись «{{work}} · {{hours}}» сотрудника {{person}} будет удалена.",
      unitPicker: {
        label: "Подразделение",
        placeholder: "Выберите подразделение",
        leadHint: "Руководитель: {{name}}",
        empty: "Выберите подразделение, чтобы открыть его отчёты",
      },
      workerPicker: {
        label: "Сотрудник",
        placeholder: "Выберите сотрудника, чтобы открыть его день",
      },
    },
    week: {
      progress: "Подтверждено {{confirmed}} / {{total}}",
      notRequiredCount: "Не требует подтверждения: {{count}}",
      nothingToApprove: "Подтверждать нечего",
      approveAll: "Подтвердить всех",
      loadError: "Не удалось загрузить недельную ленту",
      empty: "За эту неделю недельных отчётов нет",
      lens: {
        label: "Режим подтверждения",
        day: "День",
        week: "Неделя",
      },
      cell: {
        noReport: "нет отчёта",
        workLabel: "Работ",
        declaredLabel: "Табель",
        undertimeTooltip: "Недоработано: {{hours}}",
        overtimeTooltip: "Переработано: {{hours}}",
      },
      card: {
        daysLabel: "Заполняемость отчётов",
        worksLabel: "Работы на проектах",
        weekWork: "Работ за неделю: {{hours}}",
        weekDeclared: "Табель за неделю: {{hours}}",
        tabNo: "таб. №{{number}}",
        confirmed: "Подтверждено",
        notRequired: "Не требует подтверждения",
        expand: "Раскрыть",
        collapse: "Свернуть",
        unapprove: "Отменить подтверждение",
        blockedHint: "Заполните пустые дни, чтобы подтвердить неделю",
        blockedHintDraft: "Завершите черновики, чтобы подтвердить неделю",
        blockedHintMixed: "Заполните пустые дни и завершите черновики, чтобы подтвердить неделю",
        markAbsence: "Оформить отсутствие",
        problems_one: "{{count}} проблема",
        problems_few: "{{count}} проблемы",
        problems_many: "{{count}} проблем",
        problems_other: "{{count}} проблем",
      },
      summary: {
        title: "Подтверждение недели · {{range}}",
        confirmed_one: "Подтверждён: {{count}} человек · {{hours}}.",
        confirmed_few: "Подтверждены: {{count}} человека · {{hours}}.",
        confirmed_many: "Подтверждены: {{count}} человек · {{hours}}.",
        confirmed_other: "Подтверждены: {{count}} человек · {{hours}}.",
        rejectedTitle: "Не подтверждены · нужно исправить",
        notRequiredTitle: "Не требовали подтверждения: {{count}}.",
        noReport: "Нет отчёта за {{date}}",
        draftReport: "Черновик отчёта за {{date}}",
        ok: "Понятно",
      },
    },
    leadHub: {
      title: "Рабочее место руководителя",
      approval: "Подтверждение времени",
      approvalHint: "Проверить и подтвердить отчёты участка",
      workStatus: "Статусы работ",
      workStatusHint: "Отметить, как идут работы участка",
      myTime: "Моё время",
      myTimeHint: "Внести своё рабочее время",
      logout: "Выйти",
      back: "Назад",
      approvalScreenTitle: "Подтверждение",
    },
    templates: {
      title: "Шаблоны проектов",
      subtitle: "Активные и черновые версии шаблонов",
      newTemplate: "Новый шаблон",
      search: "Поиск по названию",
      statusFilter: {
        all: "Все",
        hasActive: "Активные",
        hasDraft: "С черновиками",
        archivedOnly: "Только архив",
      },
      columns: {
        name: "Шаблон",
        latestActive: "Активная",
        draft: "Черновик",
        versions: "Версии",
        actions: "Действия",
      },
      status: {
        active: "активна",
        draft: "черновик",
        archived: "архив",
        none: "—",
      },
      actions: {
        editForks: "Редактировать",
        editDraft: "Редактировать",
        promote: "Опубликовать",
        archive: "В архив",
        clone: "Клонировать",
        deleteDraft: "Удалить черновик",
      },
      empty: "Шаблоны ещё не создавались",
      readOnly: "Шаблоны может редактировать только менеджер проекта или администратор.",
      newDialog: {
        title: "Новый шаблон",
        name: "Название",
        nameHint: "Видно в списке и в шапке проекта.",
        submit: "Создать черновик",
      },
      cloneDialog: {
        title: "Клонировать шаблон",
        templateId: "Новый идентификатор",
        name: "Новое название",
        submit: "Клонировать",
      },
      promoteDialog: {
        title: "Опубликовать черновик?",
        body: "Черновик станет активной версией.",
        bodyWithActive: "Активная версия v{{version}} будет архивирована.",
        submit: "Опубликовать",
      },
      archiveDialog: {
        title: "Перенести в архив?",
        body: "Шаблон «{{name}}» не будет показываться в мастере проектов.",
        submit: "В архив",
      },
      deleteDraftDialog: {
        title: "Удалить черновик?",
        body: "Черновик «{{name}}» будет удалён без возможности восстановления. Активная версия не затрагивается.",
        submit: "Удалить",
      },
      toasts: {
        created: "Черновик шаблона создан",
        promoted: "Шаблон опубликован",
        archived: "Шаблон в архиве",
        cloned: "Шаблон клонирован",
        deleted: "Черновик удалён",
        forkOpened: "Создан черновик для редактирования",
      },
    },
    editor: {
      empty: "В шаблоне пока нет задач — добавьте задачу через кнопку выше.",
      addTask: "Добавить задачу",
      save: "Сохранить",
      saveAndPromote: "Сохранить и опубликовать",
      discard: "Удалить черновик",
      tabs: {
        workflow: "Схема",
        gantt: "Просмотр",
      },
      workflow: {
        directionLR: "Слева направо",
        directionTB: "Сверху вниз",
      },
      banner: {
        editingDraftWithActive: "Редактирование v{{version}} · активна v{{activeVersion}}",
        editingDraftNoActive: "Редактирование v{{version}} · активной версии нет",
        readOnly: "Только для чтения · {{status}} v{{version}}",
      },
      validation: {
        title: "Проверка шаблона",
        empty: "Замечаний не найдено.",
        pill: "Проверка: {{errors}} ошибок, {{warnings}} предупреждений",
        levelError: "ошибка",
        levelWarning: "предупреждение",
        errors: {
          task_no_anchor_or_dep:
            "Задача «{{task}}»: необходимо задать якорь или хотя бы одну зависимость.",
          task_anchor_and_dep:
            "Задача «{{task}}»: нельзя одновременно задать якорь и предшественников — выберите одно.",
          task_milestone_effort:
            "Задача «{{task}}» (вехи, тип {{kind}}): трудоёмкость, людей и длительность должны быть равны нулю.",
          task_regular_effort:
            "Задача «{{task}}»: трудоёмкость и количество людей должны быть больше нуля.",
          duplicate_task_ids: "В шаблоне есть повторяющиеся идентификаторы задач: {{ids}}.",
          duplicate_param_names: "В шаблоне есть повторяющиеся имена параметров: {{names}}.",
          task_unknown_dep:
            "Задача «{{task}}»: зависимость ссылается на несуществующую задачу «{{dep}}».",
          task_anchor_unknown_param:
            "Задача «{{task}}»: якорь ссылается на неизвестный параметр «{{param}}».",
          task_anchor_param_not_date:
            "Задача «{{task}}»: параметр якоря «{{param}}» должен быть типа «date», получен «{{got}}».",
          task_dep_unknown_param:
            "Задача «{{task}}»: лаг зависимости ссылается на неизвестный параметр «{{param}}».",
          dependency_cycle: "Обнаружен цикл в зависимостях: {{chain}}.",
        },
      },
      params: {
        toggle: "Параметры ({{count}})",
        empty: "Параметры ещё не добавлены.",
        add: "Добавить параметр",
        addCta: "Добавить",
        required: "Обязательный",
        types: {
          date: "дата",
          int: "число",
          string: "строка",
        },
        required_short: "обяз.",
        errors: {
          nameFormat: "Допустимы буквы, цифры, _ и -. Начало с буквы или _.",
          duplicate: "Параметр с таким именем уже есть.",
        },
      },
      gantt: {
        col: {
          unit: "Подр.",
          name: "Задача",
        },
      },
      props: {
        id: "ID",
        name: "Название",
        unit: "Подразделение",
        unitPlaceholder: "Выберите подразделение",
        kind: "Тип",
        kindOptions: {
          task: "Задача",
          milestone: "Веха",
          external_milestone: "Внешняя зависимость",
        },
        defaultPeople: "Людей по умолчанию",
        effort: "Трудоёмкость, ч.",
        durationComputed: "Длительность (расчётная): {{n}} раб. дней",
        anchorOrDeps: "Якорь / Зависимости",
        noSelection: "Выберите задачу в списке слева или в Гантте.",
        notes: "Заметки",
      },
      anchor: {
        byParam: "По параметру",
        byPredecessor: "По предшественнику",
        byPredecessorHint:
          "Связи редактируются ниже в блоке «Связи». Чтобы создать связь, перетащите на диаграмме от точки на конце задачи к началу другой; для редактирования лага используйте блок «Связи».",
      },
      task: {
        defaultName: "Новая задача",
      },
      link: {
        from: "От",
        to: "К",
        type: "Тип",
        lagNumber: "Число дней",
        lagParam: "Параметр",
        delete: "Удалить связь",
        close: "Закрыть",
        sectionTitle: "Связи (предшественники)",
        addLink: "+ Добавить связь",
        noLinks: "Нет связей.",
        chooseSource: "— выберите задачу —",
        lagLabel: "Задержка старта",
        lagDays: "дн.",
        edgeInspectorTitle: "Свойства связи",
        depType: {
          FS: { full: "Окончание – Начало", short: "ОН" },
          FF: { full: "Окончание – Окончание", short: "ОО" },
          SS: { full: "Начало – Начало", short: "НН" },
          SF: { full: "Начало – Окончание", short: "НО" },
        },
        depTypeHint: {
          FS: "Задача-последователь не может начаться до завершения предшественника.",
          FF: "Задача-последователь не может завершиться до завершения предшественника.",
          SS: "Задача-последователь может начаться только после начала предшественника.",
          SF: "Задача-последователь может завершиться только после начала предшественника.",
        },
      },
      deleteConfirm: {
        title: "Подтвердите удаление",
        taskBody: "Задача «{{name}}» будет удалена из черновика без возможности восстановления.",
        linkBody: "Связь от «{{from}}» к «{{to}}» будет удалена из черновика.",
        parameterBody:
          "Параметр «{{name}}» будет удалён из черновика без возможности восстановления.",
        tasksBody: "Задачи «{{names}}» будут удалены из черновика без возможности восстановления.",
      },
      discardDialog: {
        title: "Удалить черновик?",
        body: "Черновик «{{name}}» будет удалён без возможности восстановления. Активная версия не затрагивается.",
        submit: "Удалить",
      },
      toasts: {
        saved: "Сохранено",
        promoted: "Шаблон опубликован",
        discarded: "Черновик удалён",
      },
    },
    layout: {
      agentStub: {
        aria: "Агент Gudwin (скоро)",
        title: "Агент Gudwin",
        body: "AI-агент в разработке. После запуска: утренние сводки рисков, перепланирование и создание проектов через диалог в Telegram и в этой панели. Решения всегда за человеком, через очередь подтверждений.",
      },
      skeletonNote: "PR9b-1 skeleton — реальный layout, auth и виджеты — в PR 10.",
      bellAriaLabel: "Уведомления",
      bellTitle_one: "{{count}} ожидает согласования",
      bellTitle_few: "{{count}} ожидают согласования",
      bellTitle_many: "{{count}} ожидают согласования",
      bellTitle_other: "{{count}} ожидают согласования",
      bellEmpty: "Нет ожидающих симуляций",
      bellSeeAll: "Все согласования →",
      userMenu: {
        settings: "Настройки",
        logout: "Выйти",
      },
    },
    role: {
      admin: "Администратор",
      viewer: "Наблюдатель",
      office_staff: "Офисный сотрудник",
      worker: "Сотрудник производства",
    },
    home: {
      title: "GUDWIN",
      subtitle: "Сводка по вашим проектам и согласованиям",
      pocLink: "/poc/gantt — gating PoC из PR 9",
      widgets: {
        empty: "Виджеты для вашей роли не настроены.",
        portfolioOverview: {
          title: "Портфель проектов",
          activeBig: "Проекты в работе",
          rows: {
            in_progress: "Активные",
            planned: "Запланированы",
            completed: "Завершены",
          },
        },
        loadSummary: {
          title: "Загрузка подразделений",
          subtitle: "Топ-5 за 14 дней",
          rowFmt: "{{peak}}/{{capacity}} ч · {{overload}} дн. перегруза",
          empty: "Все подразделения в норме на горизонте 14 дней.",
        },
        recentChanges: {
          title: "Последние изменения",
          empty: "Изменений пока нет.",
        },
        pendingApprovals: {
          title: "Ожидают согласования",
          empty: "Нет активных симуляций",
          expires: "Истекает: {{when}}",
        },
        topRisks: {
          title: "Активные риски",
          empty: "Нет рисков",
          severity: {
            critical: "Критический",
            high: "Высокий",
            medium: "Средний",
            low: "Низкий",
          },
          type: {
            overdue_task: "Просроченная задача",
            approaching_deadline: "Приближается дедлайн",
            resource_overload: "Перегрузка ресурса",
            dangling_dependency: "Висячая зависимость",
            critical_path_slippage: "Сдвиг критпути",
          },
        },
      },
    },
    locale: {
      label: "Язык",
      ru: "Русский",
      en: "English",
    },
    login: {
      title: "Вход в систему",
      email: "Электронная почта",
      password: "Пароль",
      submit: "Войти",
      submitting: "Входим…",
      invalidEmail: "Введите корректный адрес электронной почты",
      passwordRequired: "Пароль обязателен",
      invalidCredentials: "Неверный адрес электронной почты или пароль",
      networkError: "Сетевая ошибка, попробуйте ещё раз",
      workerMode: {
        switchTo: "Вход по табельному номеру",
        switchBack: "Обычный вход",
        divider: "или",
      },
    },
    settings: {
      title: "Настройки",
      changePasswordLink: "Сменить пароль",
      language: "Язык интерфейса",
    },
    projects: {
      title: "Проекты",
      subtitle: "Обзор всех активных и плановых проектов",
      breadcrumb: {
        portfolio: "ПОРТФЕЛЬ",
        projects: "ПРОЕКТЫ",
      },
      counterUnit: "ПРОЕКТОВ",
      newCta: "Новый проект",
      empty: "Проектов нет",
      searchAria: "Поиск по названию, заказчику или коду",
      searchPlaceholder: "Поиск…",
      status: "Статус",
      atRisk: "Под риском",
      showArchived: "Показать архивные",
      archivedBadge: "Архив",
      overdueBadge_one: "Просрочен на {{count}} день",
      overdueBadge_few: "Просрочен на {{count}} дня",
      overdueBadge_many: "Просрочен на {{count}} дней",
      overdueBadge_other: "Просрочен на {{count}} дней",
      fromTemplate: "Из шаблона {{template}} v{{version}}",
      fromTemplateShort: "{{template}} v{{version}}",
      prev: "Назад",
      next: "Вперёд",
      pageIndicator: "Стр. {{page}} из {{total}}",
      pageRange: "{{from}}–{{to}} из {{total}}",
      dateRange: "{{start}} → {{end}}",
      noManager: "—",
      statusValues: {
        all: "Все",
        planned: "Запланирован",
        in_progress: "В работе",
        on_hold: "На паузе",
        completed: "Завершён",
        cancelled: "Отменён",
        at_risk: "Под риском",
      },
      columns: {
        code: "Номер",
        name: "Название",
        customer: "Заказчик",
        status: "Статус",
        manager: "Менеджер проекта",
        dates: "Сроки",
        progress: "Прогресс",
        plannedStart: "Старт",
        plannedEnd: "Окончание",
      },
      tabs: {
        params: "Параметры",
        tasks: "Задачи",
        gantt: "Гант",
        risks: "Риски",
        history: "История",
      },
      detail: {
        notes: "Заметки",
        stats: {
          progress: "Прогресс",
          tasks: "Задачи",
          daysToEnd: "До окончания",
        },
        workdays_one: "{{count}} раб. день",
        workdays_few: "{{count}} раб. дня",
        workdays_many: "{{count}} раб. дней",
        workdays_other: "{{count}} раб. дней",
      },
      params: {
        edit: "Редактировать",
        saved: "Сохранено",
        archive: "Архивировать",
        archiveConfirmTitle: "Архивировать проект?",
        archiveConfirmBody: "Проект «{{name}}» будет скрыт из рабочих списков.",
        unarchive: "Разархивировать",
        archived: "Проект в архиве",
        unarchived: "Проект возвращён из архива",
        delete: "Удалить навсегда",
        deleted: "Проект удалён",
        dangerTitle: "Опасная зона",
        deleteDescription: "Удалить можно только архивный проект без истории табелей.",
        deleteConfirmTitle: "Удалить проект навсегда?",
        deleteConfirmPrompt: "Введите номер проекта {{code}}, чтобы подтвердить удаление.",
        deleteConfirmAria: "Подтверждение номера проекта",
        deleteHasTimesheetHistory: "Проект нельзя удалить: с ним связана история табелей.",
        deleteBlocked: "Проект нельзя удалить.",
        close: "Закрыть проект",
        closeConfirmTitle: "Закрыть проект?",
        closeConfirmBody:
          "Проект будет помечен завершённым, дата фактического окончания — сегодня.",
        closeConfirmAction: "Закрыть проект",
        closed: "Проект завершён",
        discardTitle: "Отменить изменения?",
        discardBody: "Есть несохранённые изменения — они будут потеряны.",
        discardAction: "Отменить изменения",
        metricsEmpty: "Параметры появятся после выбора вида оборудования",
        dirtyClean: "изменений нет",
        dirtyPending: "есть несохранённые изменения",
        sections: {
          identification: "Идентификация",
          dates: "Сроки",
          responsible: "Ответственный",
          equipment: "Оборудование",
          notes: "Заметки",
        },
        fields: {
          code: "Номер проекта",
          status: "Статус",
          name: "Название",
          customer: "Заказчик",
          plannedStart: "Плановый старт",
          plannedEnd: "Плановое окончание",
          actualEnd: "Фактическое окончание",
          manager: "Менеджер проекта",
          managerPlaceholder: "Выберите менеджера проекта",
          notes: "Заметки",
        },
      },
      equipment: {
        sectionLegend: "Состав отчёта",
        typeLabel: "Вид оборудования",
        typePlaceholder: "Выберите вид оборудования",
        typeClear: "Сбросить вид оборудования",
        quantityLabel: "Количество",
        loading: "Загрузка состава…",
        error: "Не удалось загрузить состав",
        emptyElements: "Для этого вида нет элементов.",
        requiredTitle: "Обязательные элементы",
        requiredLockHint: "Обязательный элемент — входит в изделие всегда",
        selectedOptionsTitle: "Опции «Да»",
        optionalTitle: "Опции",
        yes: "Да",
        no: "Нет",
        optionAria: "{{name}}: входит в изделие?",
        optionUndecidedHint: "Решите по каждой опции — «Да» или «Нет».",
        optionUndecidedError: "Ответьте «Да» или «Нет» по каждой опции.",
        noElementHint: "Нет нужного элемента? Обратитесь к технологу — справочник ведёт он.",
        saveElementsFailed: "Проект создан, но не удалось сохранить состав элементов.",
        metrics: {
          title: "Значения параметров",
          orphanGroup: "Без элемента",
          loading: "Загрузка параметров…",
          error: "Не удалось загрузить параметры",
          choicePlaceholder: "Выберите значение",
        },
      },
      risks: {
        empty: "Нет рисков по проекту",
        includeResolved: "Показать решённые",
        hideResolved: "Скрыть решённые",
        resolvedAt: "решён {{when}}",
      },
      history: {
        empty: "Нет записей в журнале",
      },
      gantt: {
        empty: "Нет задач с датами для отображения",
        zoom: "Масштаб",
        today: "Сегодня",
        zooms: {
          day: "День",
          week: "Неделя",
          month: "Месяц",
          quarter: "Квартал",
        },
      },
      new: {
        title: "Новый проект",
        subtitle: "Выберите шаблон и заполните параметры.",
        backToList: "← К списку",
        back: "Назад",
        create: "Создать проект",
        creating: "Создаём…",
        applied: "Проект создан",
        noTemplates: "Нет активных шаблонов. Загрузите шаблон через /templates.",
        parametersLegend: "Параметры шаблона",
        parametersCount_one: "{{count}} параметр",
        parametersCount_few: "{{count}} параметра",
        parametersCount_many: "{{count}} параметров",
        parametersCount_other: "{{count}} параметров",
        steps: {
          template: "Шаблон",
          params: "Параметры",
        },
        fields: {
          code: "Номер проекта",
          projectName: "Название проекта",
          customerName: "Заказчик",
          start: "Старт",
          end: "Окончание",
          calendar: "Календарь",
          manager: "Менеджер проекта",
          managerPlaceholder: "Выберите менеджера проекта",
        },
        errors: {
          required: "Обязательное поле",
          dateFormat: "Формат даты: ГГГГ-ММ-ДД",
          integer: "Должно быть целым числом",
          codeRequired: "Введите код проекта",
          codeConflict: "Этот номер проекта уже занят",
          projectNameRequired: "Введите название проекта",
          startRequired: "Укажите дату старта",
          endRequired: "Укажите дату окончания",
          endBeforeStart: "Дата окончания не может быть раньше старта",
          positiveInteger: "Укажите целое число не меньше 1",
          calendarRequired: "Выберите календарь",
          managerRequired: "Выберите менеджера",
          createFailed: "Не удалось создать проект",
          forbidden: "Создание проектов доступно только менеджеру проекта или администратору",
        },
      },
      tasks: {
        empty: "В проекте нет задач",
        criticalPath: "На критическом пути",
        criticalPathShort: "КП",
        pin: "Закрепить",
        unpin: "Открепить",
        edit: "Редактировать",
        columns: {
          name: "Задача",
          unit: "Подразделение",
          plannedStart: "Старт",
          plannedEnd: "Окончание",
          progress: "Прогресс",
          actions: "Действия",
        },
        statuses: {
          planned: "Запланирована",
          in_progress: "В работе",
          blocked: "Заблокирована",
          completed: "Завершена",
          cancelled: "Отменена",
        },
        statusBadges: {
          inProgress: "в работе",
        },
        filters: {
          unit: "Подразделение",
          allUnits: "Все",
          criticalOnly: "Только КП",
        },
        createCta: "Задача",
        overtime: {
          title: "Сверхурочные",
          openAria: "Назначить сверхурочные",
          range: "Диапазон",
          from: "С",
          to: "По",
          hoursPerPerson: "Часов на человека",
          hoursHint: "По умолчанию рабочая смена — {{default}} ч.",
          invalidRange: "Дата «по» должна быть не раньше «с»",
          previewTitle: "Оценка (без выходных)",
          previewDays: "Рабочих дней в окне: {{count}}",
          previewHours: "Доп. чел-часов: {{hours}} ({{people}} чел.)",
          previewNote: "Точные значения — после симуляции на бэкенде с учётом календаря компании.",
          failed: "Не удалось создать симуляцию сверхурочных",
          picks: {
            today: "Сегодня",
            this_week: "Эта неделя",
            next_week: "След. неделя",
            rest_of_month: "До конца месяца",
          },
        },
        modal: {
          title: "Редактирование задачи",
          save: "Сохранить",
          saving: "Сохраняем…",
          simulate: "Симулировать",
          simulating: "Симулируем…",
          applyDirect: "Применить без симуляции",
          applyDirectTooltip:
            "Прямое сохранение без расчёта каскадных эффектов. Симуляция этого поля появится позже — см. backlog 54.",
          applying: "Применяем…",
          simulateNeedsDate: "Для симуляции изменён только новый старт.",
          simulateFailed: "Не удалось создать симуляцию",
          applyOk: "Изменения применены",
          applyFailed: "Не удалось применить изменения",
          conflict:
            "Симуляция устарела или данные изменились — обновите страницу и попробуйте снова.",
          noChanges: "Изменений нет",
          reasonRequired: "Укажите причину изменения",
          reasonHint: "Обязательно для прямой правки.",
          pinned: {
            label: "Закреплено",
            tooltip:
              "Закрепить дату начала задачи. Система не будет автоматически пересчитывать её при сдвиге связанных задач. Используется когда дата согласована с заказчиком или смежниками и не должна меняться.",
            indicator: "Закреплено: дата фиксирована",
          },
          fields: {
            name: "Название",
            unit: "Подразделение",
            unitPlaceholder: "Выберите подразделение",
            plannedStart: "Плановый старт",
            plannedEnd: "Плановое окончание",
            durationDays: "Длительность (раб. дни)",
            effortHours: "Трудозатраты (ч)",
            defaultPeople: "Людей по умолчанию",
            progressPct: "Прогресс (%)",
            status: "Статус",
            notes: "Заметки",
            reason: "Причина изменения",
          },
        },
      },
    },
    units: {
      title: "Отделы и подразделения",
      tabs: {
        structure: "Структура",
      },
      empty: "Нет подразделений",
      newCta: "Добавить",
      columns: {
        code: "Код",
        name: "Название",
        alias: "Аббр",
        capacityToday: "Доступно сегодня",
        sortOrder: "Порядок",
        status: "Статус",
        lead: "Руководитель",
        employees: "Сотрудники",
      },
      fields: {
        code: "Код",
        name: "Название",
        namePlaceholder: "Сварочный цех",
        alias: "Аббревиатура",
        aliasPlaceholder: "СЦ",
        capacityToday: "Доступно сегодня",
        subtreeCapacityToday: "Доступно с поддеревом",
        manHours: "{{value}} чел-ч",
        sortOrder: "Порядок сортировки",
        capacityWarningThreshold: "Сколько команды должно оставаться доступно, %",
        capacityWarningThresholdHint:
          "Для текущего подразделения — не менее {{available}} из 10 человек.",
        lead: "Руководитель",
        leadManager: "Вышестоящий руководитель",
        leadEmpty: "— не назначен —",
        leadClear: "Сбросить руководителя",
        parent: "Родительское подразделение",
        parentRoot: "— верхний уровень —",
        parentClear: "Сбросить родительское подразделение",
      },
      tree: {
        expand: "Развернуть",
        collapse: "Свернуть",
        addChild: "Добавить дочернее",
        rename: "Редактировать",
        move: "Переместить в…",
        delete: "Удалить",
        searchAria: "Поиск подразделения",
        searchPlaceholder: "Поиск по названию или аббревиатуре…",
        youLead: "Вы руководите",
        youDeputize: "Вы замещаете",
        employeeCount_one: "{{count}} сотрудник",
        employeeCount_few: "{{count}} сотрудника",
        employeeCount_many: "{{count}} сотрудников",
        employeeCount_other: "{{count}} сотрудника",
      },
      move: {
        title: "Переместить «{{name}}»",
        targetLabel: "Новое родительское подразделение",
        targetPlaceholder: "Выберите подразделение",
        submit: "Переместить",
        moved: "Подразделение перемещено",
        failed: "Не удалось переместить",
      },
      delete: {
        title: "Удалить «{{name}}»?",
        confirm: "Подтвердите удаление подразделения. Это действие нельзя отменить.",
        childrenNote_one: "Дочернее подразделение ({{count}}) перейдёт к вышестоящему.",
        childrenNote_other: "Дочерние подразделения ({{count}}) перейдут к вышестоящему.",
        childrenNoteRoot_one: "Дочернее подразделение ({{count}}) станет верхнего уровня.",
        childrenNoteRoot_other: "Дочерние подразделения ({{count}}) станут верхнего уровня.",
        submit: "Удалить",
        deleted: "Подразделение удалено",
        failed: "Не удалось удалить",
        blockedTitle: "Сначала переназначьте",
        blockedTasks_one: "{{count}} задача",
        blockedTasks_few: "{{count}} задачи",
        blockedTasks_many: "{{count}} задач",
        blockedMembers_one: "{{count}} человек",
        blockedMembers_few: "{{count}} человека",
        blockedMembers_many: "{{count}} человек",
        blockedHint: "Переназначьте их в другое подразделение и повторите.",
      },
      create: { title: "Новое подразделение", submit: "Создать" },
      edit: { title: "Редактирование подразделения", submit: "Сохранить" },
      params: {
        title: "Параметры подразделения",
        name: "Название",
        shortAlias: "Аббревиатура",
        sortOrder: "Порядок сортировки",
        threshold: "Порог доступности команды",
        lead: "Руководитель",
        leadPlaceholder: "Руководитель не назначен",
        noLead: "Не назначен",
        dirty: "Есть несохранённые изменения",
        clean: "Изменений нет",
        invalid: "Проверьте значение",
        discardTitle: "Отменить изменения?",
        discardBody: "Несохранённые изменения параметров будут потеряны.",
        discardAction: "Отменить изменения",
      },
      detail: {
        back: "← К списку",
        edit: "Редактировать",
        tabs: {
          employees: "Сотрудники",
          availability: "График отсутствий и переработок",
        },
        includeSubtree: "Плюс дочерние подразделения",
        previousMonth: "Предыдущий месяц",
        nextMonth: "Следующий месяц",
        currentMonth: "Текущий месяц",
        horizonLabel: "Период планирования",
        horizon_one: "{{count}} месяц",
        horizon_few: "{{count}} месяца",
        horizon_many: "{{count}} месяцев",
        loadingUnit: "Загружаем подразделение…",
        errorUnit: "Не удалось загрузить подразделение.",
        loadingPeople: "Загружаем сотрудников…",
        errorPeople: "Не удалось загрузить сотрудников.",
        emptyPeople: "В выбранном составе сотрудников нет.",
        loadingPlanning: "Загружаем план отсутствий и доступность…",
        errorPlanning: "Не удалось загрузить планирование отпусков.",
        emptyPlanning: "В выбранном составе нет данных для планирования.",
        capacityTitle: "Доступность по дням",
        capacitySubtitle: "{{months}} мес. вперёд",
        capacityHours: "Доступно, чел-ч",
        nominalHours: "Номинал, чел-ч",
        peakLabel: "Пик: {{value}}",
        empty: "Нет данных",
        legend:
          "Серый — выходной/праздник, оранжевый — переопределение календаря, синий — рабочий день",
        peopleTitle: "Сотрудники",
        viewList: "Список",
        viewPeople: "По людям",
        scopeOwn: "Свои",
        scopeSubtree: "Поддерево",
        horizonMonth: "Месяц",
        horizonQuarter: "Квартал",
        horizonYear: "Год",
      },
      deputies: {
        title: "Заместители",
        empty: "Заместителей нет",
        permanent: "Бессрочно",
        until: "до {{date}}",
        userLabel: "Сотрудник",
        userPlaceholder: "Выберите сотрудника",
        untilLabel: "Замещает до",
        untilHint: "Оставьте пустым — постоянный заместитель",
        assign: "Назначить",
        remove: "Снять",
        removeConfirmTitle: "Снять заместителя?",
        removeConfirmBody: "{{deputy}} больше не сможет действовать от имени подразделения.",
        assigned: "Заместитель назначен",
        removed: "Заместитель снят",
        assignFailed: "Не удалось назначить заместителя",
        removeFailed: "Не удалось снять заместителя",
        userRequired: "Выберите сотрудника",
        untilFuture: "Дата окончания должна быть в будущем",
      },
      approvalMode: {
        title: "Подтверждение времени",
        daily: "Ежедневно",
        weekly: "Раз в неделю",
        managedByAdmin: "Настраивает администратор",
        hint: "Влияет на рабочее место руководителя: ежедневно — дневная консоль, раз в неделю — лента недели.",
        failed: "Не удалось изменить режим подтверждения",
      },
      toast: {
        created: "Подразделение создано",
        saved: "Подразделение обновлено",
        createFailed: "Не удалось создать подразделение",
        saveFailed: "Не удалось сохранить",
      },
    },
    availability: {
      gridLabel: "Шкала доступности",
      employeeColumn: "Сотрудник",
      capacity: "Доступность команды",
      teamMemberCount_one: "{{count}} человек в подразделении",
      teamMemberCount_few: "{{count}} человека в подразделении",
      teamMemberCount_many: "{{count}} человек в подразделении",
      teamMemberCount_other: "{{count}} человека в подразделении",
      allowedAbsenceCount_one: "Без подсветки: до {{count}} отсутствующего",
      allowedAbsenceCount_few: "Без подсветки: до {{count}} отсутствующих",
      allowedAbsenceCount_many: "Без подсветки: до {{count}} отсутствующих",
      allowedAbsenceCount_other: "Без подсветки: до {{count}} отсутствующего",
      warningAbsenceCount: "Подсветка: от {{count}} отсутствующих",
      anyAbsenceWarning: "Подсветка: при любом отсутствии",
      previousMonth: "Предыдущий месяц",
      nextMonth: "Следующий месяц",
      currentMonth: "Текущий месяц",
      horizonLabel: "Горизонт планирования",
      horizon_one: "{{count}} месяц",
      horizon_few: "{{count}} месяца",
      horizon_many: "{{count}} месяцев",
      horizon_other: "{{count}} месяца",
      week: "Н{{number}}",
      weekCompact: "{{number}}",
      today: "Сегодня",
      dayOff: "Выходной",
      capacityValue: "Доступно: {{available}} из {{total}} чел.-дн.",
      tooltip: "{{date}} · {{availability}}",
      absenceIntervalLabel: "{{employee}} · {{kind}} · {{from}} — {{to}}",
      absenceReason: "Причина: {{reason}}",
      absenceHours: "Часы: +{{hours}}",
      eventTypeReason: "Причина: {{type}}",
      eventComment: "Комментарий: {{reason}}",
      durationDays_one: "Длительность: {{count}} день",
      durationDays_few: "Длительность: {{count}} дня",
      durationDays_many: "Длительность: {{count}} дней",
      durationDays_other: "Длительность: {{count}} дня",
      durationHours: "Длительность: {{hours}} ч",
      loadError: "Не удалось загрузить график",
      peopleNotFound: "Сотрудники не найдены",
      inactivePerson: "Неактивен",
      subtreeCapacityOverview:
        "Обзорная доступность по выбранному поддереву; нормативы дочерних подразделений проверяются отдельно.",
      editSchedule: "Изменить график сотрудника {{name}}",
      filters: {
        allUnits: "Все подразделения",
        unitSearch: "Найти подразделение…",
        unitsEmpty: "Подразделения не найдены",
        unitClear: "Все подразделения",
        searchAria: "Поиск сотрудника по ФИО или табельному номеру",
        searchPlaceholder: "ФИО или табельный номер",
        eventTypes: "Типы событий: {{selected}} из {{total}}",
        eventTypesSearch: "Поиск типа события…",
        eventTypesEmpty: "Типы событий не найдены",
      },
      legend: "Условные обозначения",
      legendShow: "Показать условные обозначения",
      legendHide: "Скрыть условные обозначения",
      critical: "Доступность ниже {{threshold}}%",
      absence: {
        vacation: "Отпуск",
        unpaid_leave: "Отгул за свой счёт",
        sick: "Больничный",
        no_show: "Невыход",
        day_off: "Отгул",
        part_time: "Неполный день",
        overtime: "Переработка",
      },
      empty: "Нет сотрудников",
      kind: {
        vacation: "Отпуск",
        unpaid_leave: "Отгул за свой счёт",
        sick: "Больничный",
        no_show: "Невыход",
        day_off: "Отгул",
        part_time: "Неполный день",
        overtime: "Переработка",
      },
    },
    people: {
      back: "← К подразделению",
      backUnits: "← К подразделениям",
      notFound: "Сотрудник не найден",
      scheduleTitle: "Расписание",
      calendarTitle: "Календарь",
      prevPeriod: "Назад",
      nextPeriod: "Вперёд",
      today: "Сегодня",
      records: "Запланированные отсутствия и переработки",
      recordsEmpty: "Записей нет",
      showPast: "Показать прошедшие",
      addAbsence: "Добавить отсутствие",
      addOvertime: "Добавить переработку",
      profileTitle: "Профиль",
      profileStatusActive: "Активен",
      profileStatusInactive: "Неактивен",
      profileDirty: "Есть несохранённые изменения",
      profileClean: "Изменений нет",
      profileDiscardTitle: "Отменить изменения?",
      profileDiscardBody: "Несохранённые изменения профиля будут потеряны.",
      profileDiscardAction: "Отменить изменения",
      workTypesTitle: "Основные виды работ по должности",
      workTypesInactive: " · не используется",
      workTypesLockedHint:
        "Работы должности. Меняются сменой должности или её набором в справочнике.",
      workTypesAdhocTitle: "Дополнительные виды работ",
      workTypesAdhocEmpty: "Работ сверх должности нет.",
      workTypesPicker: "Выбрать виды работ",
      workTypesSearch: "Поиск вида работы…",
      workTypesSaveFailed: "Не удалось сохранить виды работ",
      hours: "{{value}} ч",
      payableShort: "оплач.",
      project: "Проект",
      delete: "Удалить",
      deleteConfirm: "Удалить запись расписания?",
      deleteConfirmBody:
        "Запись «{{event}}» за {{from}}–{{to}} сотрудника {{person}} будет удалена.",
      leadership: {
        title: "Руководящие позиции",
        lead: "Руководитель",
        deputy: "Заместитель",
        until: "до {{date}}",
      },
      fields: {
        name: "Сотрудник",
        position: "Должность",
        unit: "Подразделение",
        calendar: "Базовый календарь",
        calendarInherited: "Как у компании",
        lineManager: "Руководитель",
        yes: "Да",
        no: "Нет",
        none: "—",
      },
      absenceForm: {
        title: "Отсутствие",
        editTitle: "Редактировать отсутствие",
        desc: "Отпуск, больничный, отгул или неполный день — снижают доступность.",
        kind: "Тип",
        kindVacation: "Отпуск",
        kindUnpaidLeave: "Отгул за свой счёт",
        kindSick: "Больничный",
        kindNoShow: "Невыход",
        kindDayOff: "Отгул",
        kindPartTime: "Неполный день",
        dateFrom: "С",
        dateTo: "По",
        hoursOff: "Минус часов в день",
        hoursOffHint: "Только для неполного дня; отпуск/больничный обнуляют день.",
        reason: "Комментарий",
        submit: "Добавить",
      },
      overtimeForm: {
        title: "Переработка",
        editTitle: "Редактировать переработку",
        desc: "Дополнительные часы по проекту — поднимают доступность.",
        kind: "Тип",
        project: "Проект",
        projectPlaceholder: "Выберите проект",
        dateFrom: "С",
        dateTo: "По",
        hours: "Плюс часов в день",
        payable: "Оплачиваемая",
        reason: "Комментарий",
        submit: "Добавить",
      },
      errors: {
        required: "Заполните поле",
        dateOrder: "Дата окончания раньше начала",
        projectRequired: "Для переработки нужен проект",
        hoursPositive: "Часы должны быть больше нуля",
        hoursRange: "Недопустимое число часов",
      },
      toast: {
        added: "Запись добавлена",
        deleted: "Запись удалена",
        addFailed: "Не удалось добавить запись",
        deleteFailed: "Не удалось удалить запись",
      },
    },
    load: {
      title: "Загрузка ресурсов",
      unit: "Подразделение",
      unitPlaceholder: "Выберите подразделение",
      from: "С",
      to: "По",
      resetRange: "Сброс диапазона",
      capacity: "Доступно, чел-ч",
      allocated: "Нагрузка, чел-ч",
      empty: "Нет данных за выбранный диапазон",
      overloadDays_one: "{{count}} день с перегрузкой",
      overloadDays_few: "{{count}} дня с перегрузкой",
      overloadDays_many: "{{count}} дней с перегрузкой",
      overloadDays_other: "{{count}} дней с перегрузкой",
      drilldown: {
        title: "Разбивка по проектам",
        subtitle: "Подразделение {{unit}} · {{date}}",
        none: "Не выбрано",
        empty: "Нет назначений на этот день",
        project: "Проект",
        people: "Чел.",
        hoursPerPerson: "Часов / чел.",
        tasks: "Задачи",
        overtime: "overtime",
      },
    },
    portfolio: {
      title: "Портфель проектов",
      empty: "Нет задач для отображения",
      projectsCount_one: "{{count}} проект",
      projectsCount_few: "{{count}} проекта",
      projectsCount_many: "{{count}} проектов",
      projectsCount_other: "{{count}} проектов",
      unitsFilter: "Подразделения",
      clearUnits: "Сбросить",
      legendMore: "и ещё {{count}}",
      taskColumn: "Задача",
      searchProjects: "Поиск по проектам",
      projectsFilter: "Проекты",
      clearProjects: "Сбросить",
      clearStatus: "Сбросить",
      statusFilter: "Статус проектов",
      tasksFilter: "Задачи",
      searchTasks: "Поиск по задачам",
      clearTasks: "Сбросить",
    },
    simulation: {
      toast: {
        overtime: "Запрос на переработку отправлен на согласование",
        taskMove: "Изменение задачи отправлено на согласование",
      },
      help: {
        trigger: "Что такое симуляция?",
        title: "Симуляция изменений",
        whatIs:
          "Симуляция — это предложение изменения, которое система рассчитывает каскадом (зависимости, загрузка отделов), но не применяет сразу. Вы видите Гант-diff и принимаете решение в /approvals.",
        whenNeeded:
          "Когда симулировать: сдвиг плановых/фактических дат, изменение длительности, состава задач, статуса — всё, что меняет расписание других задач или загрузку.",
        whenNotNeeded:
          "Когда не нужно: прогресс, имя, заметки, теги, фиксация даты — это атрибуты задачи, расписание не двигают. Сохраняются сразу, без согласования.",
        whereLives:
          "Где живёт результат: после создания симуляция появляется в иконке-колокольчике и на /approvals. Применяется или отклоняется одним кликом.",
      },
    },
    approvals: {
      title: "Согласования",
      empty: "Нет ожидающих симуляций",
      count_one: "{{count}} симуляция",
      count_few: "{{count}} симуляции",
      count_many: "{{count}} симуляций",
      count_other: "{{count}} симуляций",
      expiresIn: "Истекает через {{value}}",
      expired: "Истекла",
      timeHM: "{{h}} ч {{m}} мин",
      timeM: "{{m}} мин",
      projectEndChange: "Δ окончания проекта (дн.)",
      affectedTasks: "Задач затронуто",
      overloads: "Новых перегрузок",
      overloadsMore: "и ещё {{count}}",
      project: "Проект #{{id}}",
      kindLabel: "Тип",
      apply: "Применить",
      reject: "Отклонить",
      openGantt: "Открыть Гант",
      kind: {
        task_move: "Перенос задачи",
        task_status_change: "Изменение статуса",
        apply_template: "Применение шаблона",
        create_project_from_template: "Создание проекта",
        add_task: "Добавление задачи",
        remove_task: "Удаление задачи",
        set_allocation: "Назначение ресурсов",
        set_task_overtime: "Сверхурочные",
        set_company_calendar_override: "Календарь компании",
      },
      autoSummary: {
        task_move_one: "Сдвиг задачи «{{task_name}}» на {{count}} день",
        task_move_few: "Сдвиг задачи «{{task_name}}» на {{count}} дня",
        task_move_many: "Сдвиг задачи «{{task_name}}» на {{count}} дней",
        task_move_other: "Сдвиг задачи «{{task_name}}» на {{count}} дн.",
        task_status_change: "Статус задачи «{{task_name}}»: {{old_status}} → {{new_status}}",
        apply_template: "Применение шаблона «{{template_name}}» к проекту «{{project_name}}»",
        create_project_from_template:
          "Новый проект «{{project_name}}» из шаблона «{{template_name}}» ({{tasks_count}} задач)",
        add_task: "Добавление задачи «{{task_name}}» в проект «{{project_name}}»",
        remove_task: "Удаление задачи «{{task_name}}» из проекта «{{project_name}}»",
        set_allocation:
          "Распределение задачи «{{task_name}}»: {{old_people}} → {{new_people}} чел.",
        set_task_overtime: "Сверхурочные на задаче «{{task_name}}» ({{date_from}}–{{date_to}})",
        set_company_calendar_override: "Календарь {{date_from}}–{{date_to}}: {{hours}} ч/день",
      },
      userCommentLabel: "Комментарий",
      dialog: {
        applyTitle: "Применить симуляцию?",
        rejectTitle: "Отклонить симуляцию?",
        applyConfirm: "Применить",
        rejectConfirm: "Отклонить",
        reasonLabel: "Причина (необязательно)",
        reasonPlaceholder: "Короткий комментарий для журнала аудита",
      },
      toast: {
        applied_one: "Применено: затронута {{count}} задача",
        applied_few: "Применено: затронуто {{count}} задачи",
        applied_many: "Применено: затронуто {{count}} задач",
        applied_other: "Применено: затронуто {{count}} задач",
        rejected: "Симуляция отклонена",
        applyFailed: "Не удалось применить симуляцию",
        rejectFailed: "Не удалось отклонить симуляцию",
        conflict: "Симуляция устарела — обновите страницу и попробуйте снова",
        expired: "Симуляция истекла, создайте новую",
      },
      detail: {
        title: "Diff-Гант",
        back: "← К списку",
        expires: "истекает {{when}}",
        modeLabel: "Слой",
        noProject: "Симуляция не привязана к проекту",
        modes: {
          baseline: "Базовый план",
          simulation: "Симуляция",
          both: "Оба слоя",
        },
      },
    },
    risks: {
      title: "Риски",
      empty: "Нет рисков по выбранным фильтрам",
      countTotal_one: "{{count}} риск",
      countTotal_few: "{{count}} риска",
      countTotal_many: "{{count}} рисков",
      countTotal_other: "{{count}} рисков",
      filters: {
        severity: "Уровень риска",
        type: "Тип",
        project: "Проект",
        all: "Все",
        noProject: "Без проекта",
        unresolvedOnly: "Только активные",
        includeResolved: "Показать решённые",
        reset: "Сбросить",
        clear: "Очистить",
      },
      columns: {
        severity: "Уровень риска",
        type: "Тип",
        description: "Описание",
        project: "Проект",
        detectedAt: "Обнаружен",
        status: "Статус",
      },
      severity: {
        critical: "Критический",
        high: "Высокий",
        medium: "Средний",
        low: "Низкий",
      },
      type: {
        overdue_task: "Просроченная задача",
        approaching_deadline: "Приближается дедлайн",
        resource_overload: "Перегрузка ресурса",
        dangling_dependency: "Висячая зависимость",
        critical_path_slippage: "Сдвиг критпути",
      },
      status: {
        active: "активный",
        resolved: "решён",
      },
      resolvedAt: "решён {{when}}",
      noProject: "—",
      noProjectChip: "Без проекта",
      help: {
        aria: "Информация о рисках",
        title: "Какие риски отслеживает система",
        intro:
          "Gudwin периодически проверяет проекты и подсвечивает ситуации, требующие внимания. Уровень риска (Severity) растёт по мере серьёзности.",
        detectors: {
          overdue_task:
            "активная задача с плановым окончанием в прошлом. Уровень риска по числу дней просрочки: 1–2 дн. → низкий, 3–6 дн. → средний, 7–13 дн. → высокий, 14+ дн. → критический.",
          approaching_deadline:
            "активная задача завершается в ближайшие 5 дней. Уровень риска: 4–5 дн. → низкий, 2–3 дн. → средний, 0–1 дн. → высокий. После дедлайна задача переходит в «Просроченную задачу».",
          resource_overload:
            "загрузка подразделения превышает его ёмкость в каком-то периоде. Уровень риска по кратности превышения: ×1.00–1.24 → низкий, ×1.25–1.49 → средний, ×1.50–1.99 → высокий, ×2.0+ → критический.",
          dangling_dependency:
            "предшественник в зависимости задач отменён, а зависимая задача ещё активна. Уровень риска всегда средний — нужно либо отменить зависимую задачу, либо снять или перепривязать зависимость.",
        },
        refresh:
          "Сейчас обновление выполняется вручную. После реализации регулярного авто-refresh этот текст изменится.",
        usage:
          "Симуляции и прямые правки могут закрыть риск — он исчезнет из активных при следующем обновлении или останется в истории как решённый.",
      },
    },
    audit: {
      title: "Аудит",
      empty: "Нет записей по выбранным фильтрам",
      loadMore: "Загрузить ещё",
      loading: "Загрузка…",
      countLoaded_one: "{{count}} запись",
      countLoaded_few: "{{count}} записи",
      countLoaded_many: "{{count}} записей",
      countLoaded_other: "{{count}} записей",
      tabs: {
        plan: "Изменения плана",
      },
      filters: {
        project: "Проект",
        actor: "Автор",
        actorPlaceholder: "Имя пользователя",
        kind: "Тип",
        dateFrom: "С",
        dateTo: "По",
        all: "Все",
        noProject: "Без проекта",
        reset: "Сбросить",
      },
      kind: {
        task_move: "Перенос задачи",
        task_status_change: "Изменение статуса",
        apply_template: "Применение шаблона",
        add_task: "Добавление задачи",
        remove_task: "Удаление задачи",
        set_allocation: "Назначение ресурсов",
        set_task_overtime: "Сверхурочные",
        set_company_calendar_override: "Календарь компании",
        create_project_from_template: "Создание проекта",
        manual_edit: "Прямая правка",
        // Task 18 §2.2 — security feed. i18next с дефолтным keySeparator='.'
        // резолвит `audit.kind.auth.login.success` как вложенный объект,
        // поэтому ключи разнесены nested-tree'ом, а не как «auth.login.success».
        auth: {
          login: {
            success: "Вход",
            failed: "Неудачный вход",
          },
          account: {
            locked: "Блокировка аккаунта",
          },
          pin: {
            locked: "Блокировка PIN-кода",
          },
          password: {
            changed: "Смена пароля",
          },
        },
        admin: {
          user: {
            create: "Создание пользователя",
            patch: "Изменение сотрудника",
            deactivate: "Деактивация пользователя",
            reset_pin: "Сброс PIN-кода",
            work_types: "Изменение видов работ",
          },
        },
      },
      securityPreset: "Безопасность",
      openGantt: "Открыть Гант",
      presentation: {
        unknownEvent: "Неизвестное событие",
        unknownObject: "Объект не определён",
        unknownActor: "Автор не определён",
        systemActor: "Система",
        showDetails: "Показать подробности",
        hideDetails: "Скрыть подробности",
        changeCount_one: "{{count}} изменение",
        changeCount_few: "{{count}} изменения",
        changeCount_many: "{{count}} изменений",
        changeCount_other: "{{count}} изменений",
        reason: "Причина",
        columns: {
          details: "Подробности",
          when: "Когда",
          actor: "Автор",
          event: "Событие",
          object: "Объект",
          changes: "Изменения",
          field: "Поле",
          before: "Было",
          after: "Стало",
        },
        operation: {
          create: "Создано",
          update: "Изменено",
          delete: "Удалено",
        },
      },
      timesheet: {
        title: "История",
        subtitle: "Сырая лента строк отчётов смены.",
        forbidden: "Раздел доступен руководителю подразделения и администратору.",
        empty: "Нет записей по выбранным фильтрам",
        loadMore: "Загрузить ещё",
        loading: "Загрузка…",
        filters: {
          worker: "Сотрудник",
          project: "Проект",
          workType: "Работа",
          dateFrom: "Смена с",
          dateTo: "Смена по",
          all: "Все",
          showDeleted: "Показать удалённые",
          needsAttention: "Только требующие внимания",
          needsAttentionHelp: {
            title: "Что считается требующим внимания",
            items: [
              "Проект не распознан",
              "Запись без проекта",
              "Вид работ не распознан",
              "Табель не совпадает с нормой дня",
              "Доработка без идентификатора",
            ],
          },
          adminBackfillOnly: "Только введённые админом",
          reset: "Сбросить",
        },
        columns: {
          entryId: "№",
          when: "Когда",
          worker: "Сотрудник",
          workDate: "Дата смены",
          project: "Проект",
          work: "Работа",
          hours: "Часы",
          declared: "Табель",
          status: "Статус",
          timeToSign: "Время до сдачи",
          source: "Источник",
          actions: "",
        },
        openInBackfill: "Открыть в учёте времени",
        unknownProject: "Неизвестный проект",
        noProject: "Без проекта",
        skippedProject: "Запись без проекта — проверьте, что это намеренно.",
        unknownWorkType: "Вид работ не в справочнике",
        declaredOffNorm: "Табель не совпадает с нормой календарного дня",
        reworkUnlabeled: "Доработка без идентификатора",
        reworkUnlabeledHint: "Часы затрачены на закрытую работу — укажите идентификатор доработки.",
        replaced: "ИЗМЕНЕНА",
        deleted: "УДАЛЕНО",
        adminBackfill: "введено админом",
        adminBackfillUnknown: "админ",
        replacedBy: "→ заменена записью №{{id}}",
        replacedTooltip: "Перевведено сотрудником, заменено записью №{{id}}",
        replacedTooltipNoRef: "Перевведено сотрудником, заменено новой записью",
        userDeletedTooltip: "Удалено сотрудником",
        userDeletedAt: "Удалено сотрудником · {{at}}",
        adminDeletedTooltip: "Удалено администратором",
        adminDeletedAt: "Удалено администратором · {{at}}",
        deletedBy: "удалена · {{at}}",
        signedAt: "сдано {{at}}",
        approvedAt: "утверждено {{at}}",
        timeToSign: "до сдачи · {{value}}",
        status: {
          draft: "черновик",
          signed: "сдана",
          approved: "утверждена",
        },
        hoursSuffix: "ч",
        tab: "таб. {{value}}",
        loadError: "Не удалось загрузить ленту",
      },
    },
    calendar: {
      title: "Производственный календарь компании",
      subtitle:
        "По умолчанию следуем Закону РФ. Можно переопределить — добавить выходные или рабочие дни, изменить количество рабочих часов.",
      calendarSelect: "Календарь",
      defaultName: "Стандартный",
      standardWeek: "Стандартная неделя по умолчанию",
      standardWeekHours: "{{day}} · {{hours}} ч",
      standardWeekOff: "{{day}} · выходной",
      weekDayShort: {
        mon: "Пн",
        tue: "Вт",
        wed: "Ср",
        thu: "Чт",
        fri: "Пт",
        sat: "Сб",
        sun: "Вс",
      },
      weekDayFull: {
        mon: "Понедельник",
        tue: "Вторник",
        wed: "Среда",
        thu: "Четверг",
        fri: "Пятница",
        sat: "Суббота",
        sun: "Воскресенье",
      },
      empty: "Нет переопределений",
      newCta: "Добавить отклонение",
      forbidden: "Просмотр доступен всем, изменения — только менеджеру проекта или администратору.",
      columns: {
        dateFrom: "С",
        dateTo: "По",
        hours: "Часы",
        reason: "Причина",
        createdBy: "Автор",
        createdAt: "Создан",
        actions: "Действия",
      },
      fields: {
        dateFrom: "Дата с",
        dateTo: "Дата по",
        hours: "Часы (0 = выходной, 1–7 = сокращённый, 8 = стандарт, >8 = переработка)",
        reason: "Причина",
        editReason: "Причина изменения (для аудита)",
      },
      hoursHint: {
        zero: "праздник / выходной",
        short: "сокращённый день",
        normal: "стандартный рабочий",
        overtime: "удлинённый рабочий",
      },
      create: { title: "Новое отклонение", submit: "Создать" },
      edit: { title: "Редактирование отклонения", submit: "Сохранить" },
      delete: {
        confirmTitle: "Удалить отклонение?",
        confirmBody:
          "Отклонение с {{from}} по {{to}} на {{hours}} ч будет удалено без возможности восстановления.",
        confirm: "Удалить",
        cancel: "Отмена",
      },
      errors: {
        required: "Обязательное поле",
        dateOrder: "Дата «по» должна быть ≥ «с»",
        hoursRange: "Часы — целое от 0 до 24",
      },
      toast: {
        created: "Отклонение создано",
        saved: "Отклонение обновлено",
        deleted: "Отклонение удалено",
        createFailed: "Не удалось создать",
        saveFailed: "Не удалось сохранить",
        deleteFailed: "Не удалось удалить",
      },
    },
    admin: {
      catalogs: {
        title: "Справочники",
        subtitle: "Единые справочники для проектов и учёта времени.",
        tabs: {
          workTypes: "Виды работ",
          equipmentTypes: "Виды оборудования",
          assemblyElements: "Элементы оборудования",
          personEventTypes: "Типы отсутствий и переработок",
          positions: "Должности",
          calendar: "Производственный календарь",
        },
      },
      personEventTypes: {
        newCta: "Создать тип",
        empty: "Справочник типов пуст. Создайте первый тип.",
        noResults: "Ничего не найдено.",
        searchPlaceholder: "Поиск по названию, коду или аббревиатуре…",
        searchAria: "Поиск типа отсутствия или переработки",
        selectPrompt: "Выберите тип слева или создайте новый.",
        createTitle: "Новый тип",
        editTitle: "Параметры типа",
        create: "Создать",
        save: "Сохранить",
        delete: "Удалить",
        dragHandle: "Перетащить для сортировки",
        lockReason:
          "Тип уже используется. Название, группа, аббревиатура и код защищены; цвет, статус и порядок можно менять.",
        columns: {
          name: "Название",
          group: "Группа",
          abbreviation: "Аббр.",
          code: "Код",
          status: "Статус",
        },
        fields: {
          name: "Название",
          group: "Группа",
          color: "Цвет",
          abbreviation: "Аббревиатура",
          code: "Код",
        },
        groups: { absence: "Отсутствие", overtime: "Переработка" },
        colors: {
          gray: "Серый",
          dark: "Графитовый",
          blue: "Синий",
          yellow: "Жёлтый",
          green: "Зелёный",
          red: "Красный",
        },
        deleteDialog: {
          title: "Удалить тип «{{name}}»?",
          body: "Тип «{{name}}» будет удалён из справочника. Это действие нельзя отменить.",
        },
        errors: { nameRequired: "Введите название" },
        toast: {
          saved: "Сохранено",
          saveFailed: "Не удалось сохранить",
          reorderFailed: "Не удалось изменить порядок",
        },
      },
      positions: {
        newCta: "Добавить должность",
        empty: "Справочник должностей пуст. Создайте первую должность.",
        noResults: "Ничего не найдено.",
        searchPlaceholder: "Поиск должности…",
        searchAria: "Поиск по названию должности",
        selectPrompt: "Выберите должность слева, чтобы собрать её набор работ.",
        deleteAction: "Удалить",
        cancel: "Отмена",
        create: "Создать",
        row: {
          dragHandle: "Перетащить для сортировки",
          editHint: "Двойной клик — переименовать",
        },
        fields: {
          name: "Название",
          namePlaceholder: "Слесарь",
        },
        workTypes: {
          paneLabel: "Набор работ",
          listLabel: "В наборе должности",
          readOnlyHint: "Назначение видов работ редактируется во вкладке «Виды работ».",
        },
        createDialog: {
          title: "Новая должность",
        },
        deleteDialog: {
          title: "Удалить «{{name}}»?",
          body: "Должность «{{name}}» будет удалена без возможности восстановления.",
          submit: "Удалить",
        },
        deleteBlockedDialog: {
          title: "Нельзя удалить «{{name}}»",
          body: "Должность назначена сотрудникам. Снимите её с сотрудников или отключите должность — тогда она пропадёт из выбора, а прежние привязки останутся.",
          ok: "Понятно",
        },
        errors: {
          nameRequired: "Введите название",
        },
        toast: {
          created: "Должность создана",
          updated: "Сохранено",
          deleted: "Удалено",
          createFailed: "Не удалось создать",
          updateFailed: "Не удалось сохранить",
          deleteFailed: "Не удалось удалить",
          reorderFailed: "Не удалось изменить порядок",
          workTypesFailed: "Не удалось сохранить набор работ",
        },
      },
      equipmentTypes: {
        newCta: "Создать вид",
        empty: "Справочник видов оборудования пуст. Создайте первый вид.",
        noResults: "Ничего не найдено.",
        noCategory: "Без категории",
        searchPlaceholder: "Поиск вида оборудования…",
        searchAria: "Поиск по названию вида оборудования",
        selectPrompt: "Выберите вид оборудования слева, чтобы задать его состав.",
        status: {
          active: "АКТИВЕН",
          inactive: "ВЫКЛ",
        },
        row: {
          dragHandle: "Перетащить для сортировки",
          editHint: "Двойной клик — переименовать",
        },
        editAction: "Изменить",
        deleteAction: "Удалить",
        cancel: "Отмена",
        save: "Сохранить",
        create: "Создать",
        fields: {
          name: "Название",
          namePlaceholder: "Подъёмник колонный",
          category: "Категория",
          categoryPlaceholder: "Например, колонные",
          categoryHint: "Уже встречавшиеся:",
        },
        createDialog: {
          title: "Новый вид оборудования",
        },
        editDialog: {
          title: "Изменить вид оборудования",
        },
        renameDialog: {
          title: "Переименовать «{{name}}»",
        },
        deleteDialog: {
          title: "Удалить «{{name}}»?",
          body: "Вид оборудования «{{name}}» и его состав будут удалены без возможности восстановления.",
          submit: "Удалить",
        },
        deleteBlockedDialog: {
          title: "Нельзя удалить «{{name}}»",
          body: "Вид оборудования используется. Удалить нельзя — снимите галку «Активен», чтобы спрятать из выбора.",
          ok: "Понятно",
        },
        errors: {
          nameRequired: "Введите название",
        },
        elements: {
          listLabel: "Состав",
          searchPlaceholder: "Поиск элемента…",
          searchAria: "Поиск по названию или категории элемента",
          empty: "Каталог элементов пуст. Добавьте первый элемент.",
          noResults: "Ничего не найдено.",
          noComposition:
            "Состав вида пуст. Отключите «Скрыть отсутствующие», чтобы добавить элементы.",
          hideAbsent: "Скрывать отсутствующие",
          searchRevealNotice: "Поиск показывает все совпадения",
          addCta: "Создать элемент",
          partialLinkFailure: "Элемент создан, но не добавлен в состав. Повторите привязку.",
          retryLink: "Повторить привязку",
          addDialogTitle: "Новый элемент",
          addNameLabel: "Название элемента",
          addNamePlaceholder: "Рама",
          statusAria: "Статус элемента «{{name}}» в составе вида",
          unlinkConfirmTitle: "Убрать элемент из состава?",
          unlinkConfirmBody: "Элемент «{{element}}» будет убран из состава вида «{{type}}».",
          status: {
            none: "Нет",
            required: "Да",
            optional: "Опция",
          },
        },
        toast: {
          created: "Вид оборудования создан",
          updated: "Сохранено",
          deleted: "Удалено",
          statusUpdated: "Состав обновлён",
          elementCreated: "Элемент добавлен",
          createFailed: "Не удалось создать",
          updateFailed: "Не удалось сохранить",
          deleteFailed: "Не удалось удалить",
          reorderFailed: "Не удалось изменить порядок",
          statusFailed: "Не удалось обновить состав",
        },
      },
      assemblyElements: {
        newCta: "Создать элемент",
        empty: "Каталог элементов пуст. Создайте первый элемент.",
        noResults: "Ничего не найдено.",
        noCategory: "Без категории",
        searchPlaceholder: "Поиск элемента…",
        searchAria: "Поиск по названию или категории элемента",
        selectPrompt: "Выберите элемент слева, чтобы задать его параметры.",
        status: {
          active: "АКТИВЕН",
          inactive: "ВЫКЛ",
        },
        row: {
          dragHandle: "Перетащить для сортировки",
          editHint: "Двойной клик — переименовать",
        },
        deleteAction: "Удалить",
        editAction: "Изменить",
        cancel: "Отмена",
        save: "Сохранить",
        create: "Создать",
        fields: {
          name: "Название",
          category: "Категория",
          categoryPlaceholder: "Например, несущие элементы",
          categoryHint: "Уже встречавшиеся:",
        },
        createDialog: {
          title: "Новый элемент",
        },
        editDialog: {
          title: "Изменить элемент",
        },
        deleteDialog: {
          title: "Удалить «{{name}}»?",
          body: "Элемент «{{name}}» и его параметры будут удалены без возможности восстановления.",
          submit: "Удалить",
        },
        deleteBlockedDialog: {
          title: "Нельзя удалить «{{name}}»",
          body: "Элемент входит в состав одного или нескольких видов оборудования. Удалить нельзя — снимите галку «Активен», чтобы спрятать из выбора.",
          ok: "Понятно",
        },
        errors: {
          nameRequired: "Введите название",
        },
        metrics: {
          listLabel: "Параметры",
          empty: "У элемента пока нет параметров. Добавьте первый.",
          addCta: "Добавить параметр",
          deleteAction: "Удалить параметр",
          optionsCta: "Варианты · {{count}}",
          type: {
            number: "Число",
            choice: "Выбор",
            text: "Текст",
          },
          fields: {
            name: "Название",
            type: "Тип",
            typePlaceholder: "Выберите тип",
            typeHint: "Тип нельзя изменить после создания.",
          },
          createDialog: {
            title: "Новый параметр",
          },
          deleteDialog: {
            title: "Удалить параметр «{{name}}»?",
            body: "Параметр «{{name}}» и его варианты будут удалены без возможности восстановления.",
            submit: "Удалить",
          },
          optionsDialog: {
            title: "Варианты параметра «{{name}}»",
            empty: "Вариантов пока нет. Добавьте первый.",
            addCta: "Добавить вариант",
            valuePlaceholder: "Например, Стандартная",
            removeAria: "Удалить вариант",
            removeConfirmTitle: "Удалить вариант?",
            removeConfirmBody:
              "Вариант «{{name}}» будет удалён из черновика без возможности отмены.",
            emptyValue: "Без названия",
          },
        },
        toast: {
          created: "Элемент создан",
          updated: "Сохранено",
          deleted: "Удалено",
          metricCreated: "Параметр добавлен",
          metricDeleted: "Параметр удалён",
          optionsUpdated: "Варианты сохранены",
          createFailed: "Не удалось создать",
          updateFailed: "Не удалось сохранить",
          deleteFailed: "Не удалось удалить",
          reorderFailed: "Не удалось изменить порядок",
          optionsFailed: "Не удалось сохранить варианты",
        },
      },
      users: {
        title: "Сотрудники",
        subtitle: "Только для администраторов. Создать / отредактировать / деактивировать.",
        subtitleLead:
          "Сотрудники вашего подразделения. Создать / отредактировать / деактивировать.",
        empty: "Сотрудники не найдены",
        newCta: "Добавить сотрудника",
        statusActive: "активен",
        statusInactive: "неактивен",
        tracksTime: {
          on: "Участвует в учёте времени",
        },
        columns: {
          person: "Сотрудник",
          role: "Роль",
          unit: "Подразделение",
          status: "Статус",
          lastLogin: "Последний вход",
          actions: "Действия",
          position: "Должность",
        },
        fields: {
          last_name: "Фамилия",
          first_name: "Имя",
          patronymic: "Отчество",
          role: "Роль",
          unit: "Подразделение",
          email: "Электронная почта",
          tracksTime: "Участвует в учёте времени",
          projectManager: "Проектный менеджер",
          tabNumber: "Табельный номер",
          tabNumberOptional: "Табельный номер (необязательно)",
          tabNumberPlaceholder: "Например, 1024",
          initialPin: "Начальный ПИН",
          position: "Должность",
          positionEmptyValue: "Не выбрана",
          positionSearchPlaceholder: "Поиск должности…",
          positionNotFound: "Должность не найдена",
          positionClear: "Очистить должность",
          positionCreate: "Создать должность «{{name}}»",
          positionHint: "Виды работ придут из должности. Дополнительные — в карточке сотрудника.",
          unitPlaceholder: "Выберите подразделение",
          unitLockedHint: "Ваше подразделение — изменить нельзя.",
          schedule: "График работы",
          scheduleDefault: "Как у компании",
          scheduleHint: "Постоянный график сотрудника. По умолчанию — рабочий график компании.",
          hireDate: "Дата приёма",
          terminationDate: "Дата увольнения",
        },
        searchAria: "Поиск по ФИО или табельному номеру",
        searchPlaceholder: "Поиск по ФИО или табельному…",
        unitFilter: {
          placeholder: "Все подразделения",
          searchPlaceholder: "Поиск подразделения…",
          empty: "Подразделение не найдено",
          clear: "Сбросить фильтр по подразделению",
        },
        positionFilter: {
          placeholder: "Все должности",
          searchPlaceholder: "Поиск должности…",
          empty: "Должность не найдена",
          clear: "Сбросить фильтр по должности",
        },
        filtersReset: "Сбросить фильтры",
        activity: {
          label: "Активность",
          active: "Активные",
          inactive: "Не активные",
          all: "Все",
        },
        groupSwitcher: {
          label: "Тип пользователя",
          office: "Офисный сотрудник",
          worker: "Сотрудник производства",
        },
        actions: {
          resetPin: "Сбросить ПИН",
          resetPassword: "Сбросить пароль",
          edit: "Редактировать",
          reactivate: "Активировать",
        },
        actionReasons: {
          self_deactivation: "Нельзя деактивировать свой аккаунт",
          last_active_admin: "Нельзя деактивировать последнего активного администратора",
          inactive_account: "Аккаунт неактивен",
          active_account: "Аккаунт уже активен",
          outside_management_scope: "Сотрудник вне вашей зоны ответственности",
          protected_role: "Эта роль недоступна для управления",
          wrong_auth_method: "Для этого способа входа действие неприменимо",
        },
        create: { title: "Новый сотрудник", submit: "Создать" },
        edit: { title: "Редактирование пользователя", submit: "Сохранить" },
        deactivate: "Деактивировать",
        deactivateDialog: {
          title: "Деактивировать сотрудника?",
          body: "Доступ сотрудника {{name}} будет отозван. Данные и история останутся в системе.",
        },
        unitNone: "—",
        tempPasswordDialog: {
          title: "Пользователь создан",
          subtitle:
            "Скопируйте пароль и передайте новому пользователю. После закрытия окно увидеть его уже нельзя.",
          copy: "Скопировать",
          copied: "Скопировано",
          done: "Готово",
        },
        reactivateDialog: {
          title: "Снова активировать сотрудника?",
          body: "Активировать пользователя {{name}}?",
        },
        resetPinConfirm: {
          title: "Сбросить ПИН сотрудника?",
          body: "Текущий ПИН сотрудника {{name}} перестанет действовать. Взамен создадим новый и покажем его один раз.",
          submit: "Сбросить ПИН",
        },
        resetPinDialog: {
          title: "Новый ПИН сотрудника",
          subtitle: "{{name}} (табельный {{tab}}). Старый ПИН отозван, блокировка снята.",
          warning:
            "ПИН показан один раз. Скопируйте и передайте сотруднику до закрытия окна — восстановить его нельзя.",
          copy: "Скопировать",
          copied: "Скопировано",
          done: "Готово",
        },
        resetPasswordConfirm: {
          title: "Сбросить пароль сотрудника?",
          body: "Текущий пароль сотрудника {{name}} перестанет действовать, а открытые сессии завершатся. Взамен создадим временный пароль и покажем его один раз.",
          submit: "Сбросить пароль",
        },
        resetPasswordDialog: {
          title: "Новый пароль сотрудника",
          subtitle: "{{name}}. Старый пароль отозван, сессии завершены.",
          warning:
            "Пароль показан один раз. Скопируйте и передайте сотруднику до закрытия окна — восстановить его нельзя.",
          copy: "Скопировать",
          copied: "Скопировано",
          done: "Готово",
        },
        errors: {
          required: "Обязательное поле",
          emailFormat: "Неверный формат адреса электронной почты",
          unitRequired: "Выберите подразделение",
          tabFormat: "Табельный — 3-6 цифр",
          pinFormat: "ПИН — ровно 4 цифры",
          employmentDateOrder: "Дата увольнения не может быть раньше даты приёма",
          projectManagerRole: "Сначала снимите признак проектного менеджера, затем измените роль",
        },
        toast: {
          created: "Пользователь создан",
          workerCreated: "Сотрудник производства заведён",
          positionCreateFailed: "Не удалось создать должность",
          saved: "Пользователь обновлён",
          deactivated: "Пользователь деактивирован",
          reactivated: "Пользователь активирован",
          createFailed: "Не удалось создать",
          saveFailed: "Не удалось сохранить",
          deactivateFailed: "Не удалось деактивировать",
          reactivateFailed: "Не удалось активировать",
          resetPinFailed: "Не удалось сбросить ПИН",
          resetPasswordFailed: "Не удалось сбросить пароль",
        },
        guards: {
          selfDeactivate: "Нельзя деактивировать свой аккаунт",
          selfRoleAdmin: "Нельзя снять admin-роль с собственного аккаунта",
          lastAdmin: "Нельзя деактивировать последнего активного администратора",
          lastAdminRole: "Нельзя снять admin-роль с последнего активного администратора",
        },
      },
      checklist: {
        title: "Контрольные точки",
        paneAria: "Контрольные точки вида работ",
        pickWorkType: "Выберите вид работ слева, чтобы настроить его контрольные точки",
        empty:
          "У этого вида работ контрольных точек нет. Добавьте первую — она попадёт в новые работы.",
        addCta: "Добавить контрольную точку",
        createDialogTitle: "Новая контрольная точка",
        titleLabel: "Название",
        titleRequired: "Введите название",
        create: "Добавить",
        editHint: "Дважды нажмите, чтобы переименовать",
        dragAria: "Переместить контрольную точку",
        deleteAria: "Удалить контрольную точку",
        activeF: "АКТИВНА",
        inactiveF: "ВЫКЛЮЧЕНА",
        deleteConfirmTitle: "Удалить контрольную точку из справочника?",
        deleteConfirmBody:
          "Контрольная точка «{{title}}» перестанет попадать в новые работы. В работах, где она уже стоит, точка сохранится вместе с отметкой.",
        toast: {
          created: "Контрольная точка добавлена",
          createFailed: "Не удалось добавить контрольную точку",
          updated: "Контрольная точка обновлена",
          updateFailed: "Не удалось обновить контрольную точку",
          deleted: "Контрольная точка удалена",
        },
        condition: {
          none: "Без условий — попадает во все работы этого вида",
          addCta: "Добавить условие",
          equipment: "Вид оборудования",
          element: "Элемент",
          anyEquipment: "Любой вид оборудования",
          anyElement: "Любой элемент",
          saveCta: "Добавить",
          clear: "Очистить",
          notFound: "Ничего не найдено",
          removeAria: "Снять условие",
          hint: "Контрольная точка попадёт в работу, если проект подходит хотя бы под одно условие. Внутри одного условия «+» значит «и то, и другое».",
          removeConfirmTitle: "Снять условие?",
          removeConfirmBody:
            "Условие «{{condition}}» перестанет действовать: контрольная точка начнёт попадать в работы, которые под него не подходят.",
        },
      },
      workTypes: {
        title: "Виды работ",
        subtitle: "Справочник видов работ. Видны сотрудникам при заполнении смены.",
        newCta: "Создать вид работы",
        empty: "Справочник пуст. Создайте первый вид работ.",
        searchPlaceholder: "Поиск вида работы…",
        searchAria: "Поиск по названию вида работы",
        noResults: {
          active: "Среди активных видов работ ничего не найдено.",
          all: "Среди всех видов работ ничего не найдено.",
        },
        activity: {
          label: "Активность",
          active: "Активные",
          all: "Все",
        },
        noCategory: "Без категории",
        positions: {
          title: "Доступно для должностей",
          more: "ещё {{count}}",
          edit: "Изменить",
          search: "Поиск должности…",
          searchEmpty: "Ничего не найдено",
          empty: "Недоступно ни для одной должности",
          active: "АКТИВНА",
          inactive: "ВЫКЛЮЧЕНА",
          saveFailed: "Не удалось сохранить должности",
        },
        selectPrompt: "Выберите вид работы слева, чтобы открыть список видов задач.",
        sortHint: "Перетягивать нельзя — пользуйтесь стрелками для порядка.",
        listLabel: "Виды работ",
        detailLabel: "Виды задач",
        statusActive: "активен",
        statusInactive: "неактивен",
        active: "Активен",
        status: {
          active: "АКТИВЕН",
          inactive: "ВЫКЛ",
        },
        row: {
          dragHandle: "Перетащить для сортировки",
          editHint: "Двойной клик — переименовать",
        },
        moveUp: "Выше",
        moveDown: "Ниже",
        rename: "Переименовать",
        editAction: "Изменить",
        deleteAction: "Удалить",
        cancel: "Отмена",
        save: "Сохранить",
        create: "Создать",
        fields: {
          name: "Название",
          namePlaceholder: "Сварка",
          category: "Категория",
          categoryPlaceholder: "Например, производство",
          categoryHint: "Уже встречавшиеся:",
        },
        createDialog: {
          title: "Новый вид работы",
        },
        editDialog: {
          title: "Изменить вид работы",
        },
        renameDialog: {
          title: "Переименовать «{{name}}»",
        },
        deleteDialog: {
          title: "Удалить «{{name}}»?",
          body: "Вид работы «{{name}}» будет удалён без возможности восстановления.",
          submit: "Удалить",
        },
        deleteBlockedDialog: {
          title: "Нельзя удалить «{{name}}»",
          body: "Запись используется в отчётах смен. Удалить нельзя — снимите галку «Активен», чтобы спрятать из новых отчётов.",
          ok: "Понятно",
        },
        errors: {
          nameRequired: "Введите название",
          nameDuplicate: "Вид работы с таким названием уже существует",
        },
        toast: {
          created: "Вид работы создан",
          updated: "Сохранено",
          deleted: "Удалено",
          createFailed: "Не удалось создать",
          updateFailed: "Не удалось сохранить",
          deleteFailed: "Не удалось удалить",
          reorderFailed: "Не удалось изменить порядок",
        },
      },
      backfill: {
        kicker: "Учёт времени",
        title: "Учёт времени сотрудников",
        subtitle: "Заполните смену за нужное число или отредактируйте существующую.",
        forbidden: "Доступно только администратору или руководителю подразделения.",
        loadError: "Не удалось загрузить смену.",
        emptyHint: "Выберите сотрудника и дату, чтобы открыть смену.",
        cancel: "Отмена",
        fields: {
          worker: "Сотрудник",
          workerPlaceholder: "— выбрать сотрудника —",
          workersError: "Не удалось загрузить список сотрудников.",
          date: "Дата",
          today: "Сегодня",
        },
        status: {
          draft: "черновик",
          signed: "сдана",
          approved: "утверждена",
        },
        entries: {
          empty: "За эту дату ещё нет записей.",
          col: {
            project: "Проект",
            workType: "Работа",
            hours: "Часы",
          },
          delete: "Удалить",
          edit: "Изменить запись",
          deleted: "Запись удалена",
          deleteFailed: "Не удалось удалить",
          deleteConfirmTitle: "Удалить запись?",
          deleteConfirmOk: "Удалить",
        },
        composer: {
          title: "Добавить запись",
          workType: "Работа",
          workTypePlaceholder: "— выбрать —",
          workTypeFree: "Своя работа…",
          workTypeFreePlaceholder: "Описание работы",
          project: "Проект",
          projectSkip: "Без проекта",
          hours: "Часы",
          submit: "Записать",
          created: "Запись добавлена",
          createFailed: "Не удалось сохранить",
        },
        project: {
          placeholder: "— выбрать проект —",
          searchPlaceholder: "Код или название проекта",
          hint: "Введите код или название.",
          empty: "Совпадений нет.",
          unknownTag: "вне справочника",
          recordAsIs: "Записать «{{code}}» как есть",
          clearAria: "Очистить проект",
          confirmTitle: "Проект вне справочника",
          confirmBody:
            "Такого проекта в справочнике нет. Записать код «{{code}}» как есть? Руководитель сможет привязать его позже.",
          confirmCancel: "Отмена",
          confirmOk: "Записать как есть",
        },
        sign: {
          sumLabel: "Сумма записей",
          declaredLabel: "Табель",
          cta: "Сдать",
          confirmTitle: "Сдать отчёт?",
          confirmBody: "Сдать отчёт сотрудника {{name}} за {{date}}?",
          confirmOk: "Сдать",
          toast: "Отчёт сдан",
          failed: "Не удалось сдать отчёт",
        },
      },
    },
    field: {
      shell: {
        logout: "Выход",
        context: {
          timesheet: "Смена",
          sign: "Отчёт",
        },
        placeholder: {
          timesheet: "Загрузка",
          sign: "Отчёт смены",
        },
      },
      login: {
        title: "Табельный номер",
        subtitle: "От 3 до 6 цифр",
        backToOffice: "Обычный вход",
        digitsAria: "Введено {{filled}} цифр",
        errors: {
          invalidCredentials: "Неверный табельный или ПИН",
          accountDisabled: "Учётная запись отключена. Обратитесь к руководителю.",
          networkError: "Сетевая ошибка, попробуйте ещё раз",
        },
      },
      logout: "Выход",
      titles: {
        today: "На сегодня",
        week: "На неделю",
        overdue: "Просрочено",
      },
      tabs: {
        today: "Сегодня",
        week: "Неделя",
        overdue: "Просрочено",
      },
      empty: {
        today: "На сегодня задач нет",
        week: "На ближайшую неделю задач нет",
        overdue: "Просроченных задач нет",
      },
      offline: {
        banner: "Нет связи. Действия временно недоступны, комментарии сохраняются локально.",
        toast: {
          savedLocally: "Сохранено локально, отправим при возвращении сети",
          dropped: "Не удалось отправить запись после возвращения сети",
        },
      },
      card: {
        dates: "Даты",
        status: "Статус",
        progress: "Прогресс",
      },
      status: {
        planned: "Запланирована",
        in_progress: "В работе",
        completed: "Завершена",
        blocked: "Заблокирована",
        cancelled: "Отменена",
      },
      actions: {
        start: "Начал",
        finish: "Завершил",
        comment: "Комментарий",
      },
      comment: {
        title: "Комментарий по задаче",
        placeholder: "Что хочется зафиксировать?",
        offlineHint: "Нет связи — комментарий сохранится локально, отправите при появлении сети.",
      },
      toast: {
        started: "Отмечено: начал",
        finished: "Отмечено: завершил",
        commentSaved: "Комментарий сохранён",
        actionFailed: "Не удалось выполнить действие",
      },
      pin: {
        title: "ПИН-код",
        context: {
          login: "Вход в систему",
          sign: "Сдача отчёта",
        },
        submitting: "Проверка…",
        dotsAria: "Введено {{filled}} из {{length}}",
        error: {
          attempt: "Неверный ПИН · попытка {{attempt}} из {{max}}",
          invalid: "Неверный ПИН",
        },
        lockout: {
          message: "Учётная запись заблокирована. Обратитесь к руководителю.",
          close: "Закрыть",
        },
      },
      main: {
        date: {
          today: "Сегодня",
          yesterday: "Вчера",
          dayBefore: "Позавчера",
          changeAria: "Сменить дату",
        },
        backfill: {
          label: "Заполнение с опозданием",
          days_one: "день назад",
          days_few: "дня назад",
          days_many: "дней назад",
          days_other: "дней назад",
        },
        dateSheet: {
          title: "За какой день?",
        },
        stat: {
          totalWorks: "Итого работ",
          norm: "По табелю {{hours}}",
        },
        entries: {
          empty: "Записей пока нет",
          editAria: "Изменить запись",
          deleteAria: "Удалить запись",
          deleteTitle: "Удалить запись?",
          deleteBody: "Запись удалится из смены. Это действие нельзя отменить.",
          deleteOk: "Удалить",
          deleteCancel: "Отмена",
          deleteToastFailed: "Не удалось удалить запись",
          unknownProject: "нет в системе",
          noProject: "Без проекта",
        },
        emptyState: {
          title: "Пока ничего не записано",
          subtitle: "Тапни кнопку ниже, чтобы добавить первую работу",
          hint: "начни отсюда ↓",
        },
        trackingOff: {
          title: "Учёт времени отключён",
          subtitle: "Ваше время сейчас не учитывается. Обратитесь к руководителю.",
        },
        addEntry: "Добавить работу",
        addMore: "Добавить ещё работу",
        addMoreHint: "всё внесено? тогда «сдать»",
        total: "Итого",
        sign: "Сдать",
        signDisabledHint: "Добавьте хотя бы одну запись",
        delete: {
          title: "Удалить запись?",
          description: "Запись и часы будут удалены из отчёта.",
          confirm: "Удалить",
          cancel: "Отмена",
        },
        toast: {
          entryDeleted: "Запись удалена",
          entryDeleteFailed: "Не удалось удалить запись",
        },
        error: {
          backfillWindow: "Заполнить нельзя — слишком давно. Обратитесь к руководителю.",
        },
        readonly: {
          signed: "Отчёт сдан",
          approved: "Отчёт утверждён руководителем",
          editHint: "Изменения сразу войдут в сданный отчёт.",
          edit: "Изменить отчёт",
        },
      },
      entryFlow: {
        stepCounter: "Шаг {{current}} из {{total}}",
        editBadge: "Изменение записи",
        dockTitle: "Внесение записи времени",
        dockDescription: "Работа, проект и часы за выбранный день.",
        closeAria: "Закрыть",
        cancel: "Отмена",
        continue: "Дальше",
        saving: "Сохраняем…",
        submitCta: "Сохранить · {{hours}}",
        closeConfirmTitle: "Закрыть без сохранения?",
        closeConfirmBody: "Введённые данные пропадут.",
        closeConfirmCancel: "Назад",
        closeConfirmOk: "Закрыть",
        deleteAria: "Удалить запись",
        deleteTitle: "Удалить запись?",
        deleteBody: "Запись и часы будут удалены из отчёта.",
        deleteBodyNamed: "Запись «{{name}}» и её часы будут удалены из отчёта.",
        deleteOk: "Удалить",
        pill: {
          workType: "работа",
          project: "проект",
          projectSkipped: "без проекта",
          element: "элемент",
          elementSkipped: "без элемента",
          elementFallback: "элемент",
          clearAria: "Изменить шаг",
        },
        step1: {
          title: "Работа",
          customCta: "Написать свою работу",
          customLabel: "Своя работа",
          customPlaceholder: "Например: погрузка металла",
        },
        step2: {
          title: "Номер проекта",
          recentHint: "Последние",
          manualCta: "Ввести номер вручную",
          searchHint: "Введите хотя бы одну цифру номера проекта",
          emptyShort: "Совпадений нет — попробуйте другой номер.",
          recordAsIs: "Записать как есть",
          padAria: "Цифры номера проекта",
          unknownProjectTitle: "Такого проекта нет в системе",
          unknownProjectBody:
            "Проект «{{code}}» не найден. Проверьте номер. Если уверены — записать как есть, руководитель разберётся.",
          unknownProjectCancel: "Проверить",
          unknownProjectOk: "Записать как есть",
          skipCta: "Без проекта",
        },
        step3: {
          title: "Элемент",
          loading: "Загружаем элементы…",
          empty: "У проекта нет элементов",
          skipCta: "Без элемента",
          skipEmptyCta: "Продолжить без элемента",
        },
        step4: {
          title: "Сколько часов?",
          hint: "Шаг 0.5 часа · от 0.5 до 24",
          required: "Укажите количество часов",
        },
        rework: {
          badge: "Доработка",
          bannerTitle: "Это доработка",
          bannerBody: "Работа была закрыта {{date}}. Укажите, что дорабатываете.",
          bannerBodyNoDate: "Работа была закрыта ранее. Укажите, что дорабатываете.",
          noteLabel: "Идентификатор доработки",
          notePlaceholder: "Идентификатор доработки — напр.: замечание ОТК",
        },
        toast: {
          saveFailed: "Не удалось сохранить запись",
          deleteFailed: "Не удалось удалить запись",
          conflict: "Запись изменена, обновите экран",
        },
      },
      sign: {
        loading: "Загрузка отчёта",
        back: {
          aria: "Назад к работам",
        },
        summary: {
          title: "Сводка отчёта",
          total: "Всего работ",
          empty: "Записей нет — отчёт можно сдать, часы уйдут в «Не расписано».",
        },
        declared: {
          title: "Табель",
          edit: "изменить",
        },
        tabelEdit: {
          title: "Табель за смену",
          calendarHint: "По производственному календарю — {{hours}}",
          overtimeBadge: "Переработка +{{hours}} ч",
          overtimeBody: "Изменение табеля выше нормы потребует согласования с руководством.",
          cancel: "Отмена",
          apply: "Применить",
          confirmOvertime: "Подтвердить переработку",
          stepperAria: "Табельные часы",
        },
        button: "Сдать",
        pinTitle: "Сдача отчёта",
        confirm: {
          title: "Сдача отчёта",
          body: "Отчёт будет сдан от вашего имени.",
          submitting: "Отправляем…",
        },
        toast: {
          submitted: "Отчёт отправлен",
          failed: "Не удалось отправить отчёт",
          alreadyApproved: "Отчёт уже утверждён руководителем",
          backfillExceeded: "Заполнить нельзя — слишком давно. Обратитесь к руководителю.",
        },
      },
      tabel: {
        warning: {
          over: "{{hours}} — выше нормы дня ({{norm}}).",
          overApprovalNote: "Потребуется согласование с руководителем.",
          under: "{{hours}} — ниже нормы дня ({{norm}}).",
        },
      },
    },
    changePassword: {
      title: "Смена пароля",
      loggedInAs: "Вы вошли как {{name}} ({{email}})",
      logout: "Выйти",
      cancel: "Отмена",
      current: "Текущий пароль",
      next: "Новый пароль",
      confirm: "Подтверждение",
      submit: "Сохранить",
      submitting: "Сохраняем…",
      required: "Поле обязательно",
      mismatch: "Пароли не совпадают",
      invalidCurrent: "Неверный текущий пароль",
      networkError: "Сетевая ошибка, попробуйте ещё раз",
      policy: {
        heading: "Требования к паролю",
        length: "Длина не меньше 12 символов",
        minClasses: "Минимум 3 из 4 типов символов",
        lower: "строчные буквы",
        upper: "прописные буквы",
        digit: "цифры",
        special: "спецсимволы",
        error:
          "Пароль не отвечает требованиям: длина не меньше 12 символов и минимум 3 из 4 типов символов (строчные, прописные, цифры, спецсимволы).",
      },
    },
    gantt: {
      criticalMarker: "Критический путь",
      cpToggle: {
        label: "Критпуть",
        ariaOn: "Скрыть критический путь",
        ariaOff: "Показать критический путь",
      },
      search: {
        empty: "По запросу «{{query}}» ничего не найдено",
        clear: "Очистить фильтр",
      },
      toolbar: {
        zoom: {
          day: "День",
          week: "Нед",
          month: "Мес",
          quarter: "Кв",
        },
        today: {
          label: "К текущей дате",
          lineToggle: "Линия «сегодня»",
        },
        density: {
          compact: "Компактно",
          normal: "Обычно",
        },
        cp: {
          label: "Крит путь",
          counter: "{{cp}}/{{total}}",
          days: "{{days}} дн",
          progress: "{{progress}}%",
        },
        search: {
          placeholder: "Найти задачу…",
          ariaLabel: "Поиск по задачам",
        },
        download: {
          label: "Скачать",
          notReady: "Экспорт пока не готов — будет в следующих версиях",
        },
      },
      legend: {
        task: "Задача",
        cp: "Критпуть",
        milestone: "Веха",
        dep: "Связь",
        depCp: "Связь КП",
        today: "Сегодня",
        projectColor: "Цвет = проект",
      },
      help: {
        aria: "Легенда диаграммы Ганта",
        title: "Легенда",
      },
    },
  },
};

export interface Resources {
  translation: {
    common: {
      appName: string;
      loading: string;
      error: string;
      apiError: {
        fallback: string;
        requestId: string;
      };
      retry: string;
      save: string;
      cancel: string;
      delete: string;
      confirm: string;
      close: string;
      clear: string;
      back: string;
      notFound: string;
      elementLabel: string;
      statusToggle: {
        on: string;
        off: string;
      };
      workTypeSet: {
        addCta: string;
        searchPlaceholder: string;
        searchEmpty: string;
        empty: string;
        remove: string;
        removeConfirmTitle: string;
        removeConfirmBody: string;
      };
      combobox: {
        searchPlaceholder: string;
        empty: string;
      };
      multiSelect: {
        selectAll: string;
        clearAll: string;
        selected: string;
      };
      dateField: {
        placeholder: string;
        previousMonth: string;
        nextMonth: string;
        clear: string;
        weekdays: {
          mon: string;
          tue: string;
          wed: string;
          thu: string;
          fri: string;
          sat: string;
          sun: string;
        };
      };
      passwordInput: {
        show: string;
        hide: string;
      };
      relativeTime: {
        today: string;
      };
      releaseUpdate: {
        available: string;
        action: string;
      };
    };
    validation: {
      required: string;
      invalidType: string;
      invalidValue: string;
      invalidFormat: string;
      notMultipleOf: string;
      tooShort: string;
      tooLong: string;
      numberTooSmall: string;
      numberTooBig: string;
      tooSmall: string;
      tooBig: string;
      endBeforeStart: string;
      emailInvalid: string;
      emailReservedDomain: string;
      fieldErrorCount_one: string;
      fieldErrorCount_few: string;
      fieldErrorCount_many: string;
      fieldErrorCount_other: string;
    };
    errorBoundary: {
      eyebrow: string;
      title: string;
      body: string;
      requestIdLabel: string;
      requestIdHint: string;
      noRequestId: string;
      copy: string;
      copied: string;
      copyFailed: string;
      reload: string;
    };
    nav: {
      breadcrumb: string;
      home: string;
      projects: string;
      approvals: string;
      risks: string;
      portfolio: string;
      load: string;
      units: string;
      people: string;
      new: string;
      templates: string;
      audit: string;
      calendar: string;
      settings: string;
      "change-password": string;
      admin: string;
      users: string;
      catalogs: string;
      "time-approval": string;
      "work-status": string;
      login: string;
      collapse: string;
      expand: string;
      approvalDetail: string;
      section: {
        myWork: string;
        decisions: string;
        reference: string;
      };
    };
    peopleHub: {
      title: string;
      tabs: {
        employees: string;
        structure: string;
        availability: string;
      };
    };
    peopleCard: {
      readOnly: string;
    };
    workStatus: {
      title: string;
      pickUnit: string;
      empty: string;
      emptySearch: string;
      search: {
        aria: string;
        placeholder: string;
      };
      filters: {
        reset: string;
      };
      updated: {
        actualized: string;
        tracked: string;
      };
      columns: {
        work: string;
        performer: string;
        status: string;
        forecast: string;
        dueDate: string;
        checkpoints: string;
        updated: string;
      };
      status: {
        planned: string;
        in_progress: string;
        paused: string;
        completed: string;
      };
      forecast: {
        gt2w: string;
        w2: string;
        w1: string;
        d3: string;
        d1: string;
      };
      checkpoints: {
        done: string;
        open: string;
      };
      overdueBadge_one: string;
      overdueBadge_few: string;
      overdueBadge_many: string;
      overdueBadge_other: string;
      panel: {
        status: string;
        forecast: string;
        completedAt: string;
        dueDate: string;
        dueDateEmpty: string;
        completedAtHint: string;
        checkpoints: string;
        noCheckpoints: string;
        addCheckpoint: string;
        addCheckpointPlaceholder: string;
        removeCheckpoint: string;
        removeCheckpointConfirmTitle: string;
        removeCheckpointConfirmBody: string;
        comment: string;
        commentPlaceholder: string;
        history: string;
        noHistory: string;
        noPerformer: string;
        updatedAt: string;
        event: {
          status: string;
          forecast: string;
          dueDate: string;
          completedAt: string;
          memoQuote: string;
          checkpoint: {
            done: string;
            pending: string;
            added: string;
            removed: string;
          };
        };
      };
    };
    timeApproval: {
      title: string;
      subtitle: string;
      selfSubtitle: string;
      tabs: {
        console: string;
        entry: string;
        history: string;
      };
      entryTab: {
        dateLabel: string;
        selfHint: string;
        selfSubjectLabel: string;
        empty: string;
      };
      week: string;
      prevWeek: string;
      nextWeek: string;
      thisWeek: string;
      legendTitle: string;
      legendPending: string;
      legendMissing: string;
      legendDone: string;
      ctxPending: string;
      ctxMissing: string;
      ctxApproved: string;
      chipDoneAria: string;
      chipNoDataAria: string;
      noUnit: string;
      loadError: string;
      feedHeader: string;
      feedEmpty: string;
      you: string;
      badgeWaiting: string;
      discTitle: string;
      discOverNorm: string;
      discUnderNorm: string;
      discAbsence: string;
      markBadge: string;
      markReason: string;
      badgeApproved: string;
      footNorm: string;
      footTasks: string;
      footDeclaredVsNorm: string;
      elementMissing: {
        title: string;
        body: string;
      };
      edit: string;
      openDay: string;
      approve: string;
      cancelApproval: string;
      approving: string;
      compactDeclared: string;
      compactTasks: string;
      approveError: string;
      cancelError: string;
      missingTitle: string;
      missingExpand: string;
      missingCollapse: string;
      missingHint: string;
      missingEmpty: string;
      missingBadge: string;
      enter: string;
      absence: string;
      dockEnterTitle: string;
      dockEditTitle: string;
      dockSelfEnterTitle: string;
      dockSelfEditTitle: string;
      dockEnteredByLead: string;
      dockEditClarify: string;
      dockSubject: string;
      dockDeclared: string;
      dockRecords: string;
      dockNoRecords: string;
      dockAddRecord: string;
      dockEditRecord: string;
      dockConfirm: string;
      dockSign: string;
      dockSaving: string;
      composerProject: string;
      composerWorkType: string;
      composerHours: string;
      composerFreeWorkType: string;
      composerAdd: string;
      composerCancel: string;
      absenceTitle: string;
      absenceReasonLabel: string;
      absenceReasonNoShow: string;
      absenceReasonSick: string;
      absenceReasonDayOff: string;
      absenceReasonOther: string;
      absenceNote: string;
      absenceSave: string;
      absenceSaved: string;
      absenceError: string;
      enteredOk: string;
      signedOk: string;
      enterError: string;
      entryDeleted: string;
      entryDeleteError: string;
      entryDeleteTitle: string;
      entryDeleteBody: string;
      unitPicker: {
        label: string;
        placeholder: string;
        leadHint: string;
        empty: string;
      };
      workerPicker: {
        label: string;
        placeholder: string;
      };
    };
    week: {
      progress: string;
      notRequiredCount: string;
      nothingToApprove: string;
      approveAll: string;
      loadError: string;
      empty: string;
      lens: {
        label: string;
        day: string;
        week: string;
      };
      cell: {
        noReport: string;
        workLabel: string;
        declaredLabel: string;
        undertimeTooltip: string;
        overtimeTooltip: string;
      };
      card: {
        daysLabel: string;
        worksLabel: string;
        weekWork: string;
        weekDeclared: string;
        tabNo: string;
        confirmed: string;
        notRequired: string;
        expand: string;
        collapse: string;
        unapprove: string;
        blockedHint: string;
        blockedHintDraft: string;
        blockedHintMixed: string;
        markAbsence: string;
        problems_one: string;
        problems_few: string;
        problems_many: string;
        problems_other: string;
      };
      summary: {
        title: string;
        confirmed_one: string;
        confirmed_few: string;
        confirmed_many: string;
        confirmed_other: string;
        rejectedTitle: string;
        notRequiredTitle: string;
        noReport: string;
        draftReport: string;
        ok: string;
      };
    };
    leadHub: {
      title: string;
      approval: string;
      approvalHint: string;
      workStatus: string;
      workStatusHint: string;
      myTime: string;
      myTimeHint: string;
      logout: string;
      back: string;
      approvalScreenTitle: string;
    };
    templates: {
      title: string;
      subtitle: string;
      newTemplate: string;
      search: string;
      statusFilter: {
        all: string;
        hasActive: string;
        hasDraft: string;
        archivedOnly: string;
      };
      columns: {
        name: string;
        latestActive: string;
        draft: string;
        versions: string;
        actions: string;
      };
      status: {
        active: string;
        draft: string;
        archived: string;
        none: string;
      };
      actions: {
        editForks: string;
        editDraft: string;
        promote: string;
        archive: string;
        clone: string;
        deleteDraft: string;
      };
      empty: string;
      readOnly: string;
      newDialog: {
        title: string;
        name: string;
        nameHint: string;
        submit: string;
      };
      cloneDialog: {
        title: string;
        templateId: string;
        name: string;
        submit: string;
      };
      promoteDialog: {
        title: string;
        body: string;
        bodyWithActive: string;
        submit: string;
      };
      archiveDialog: {
        title: string;
        body: string;
        submit: string;
      };
      deleteDraftDialog: {
        title: string;
        body: string;
        submit: string;
      };
      toasts: {
        created: string;
        promoted: string;
        archived: string;
        cloned: string;
        deleted: string;
        forkOpened: string;
      };
    };
    editor: {
      empty: string;
      addTask: string;
      save: string;
      saveAndPromote: string;
      discard: string;
      tabs: {
        workflow: string;
        gantt: string;
      };
      workflow: {
        directionLR: string;
        directionTB: string;
      };
      banner: {
        editingDraftWithActive: string;
        editingDraftNoActive: string;
        readOnly: string;
      };
      validation: {
        title: string;
        empty: string;
        pill: string;
        levelError: string;
        levelWarning: string;
        errors: {
          task_no_anchor_or_dep: string;
          task_anchor_and_dep: string;
          task_milestone_effort: string;
          task_regular_effort: string;
          duplicate_task_ids: string;
          duplicate_param_names: string;
          task_unknown_dep: string;
          task_anchor_unknown_param: string;
          task_anchor_param_not_date: string;
          task_dep_unknown_param: string;
          dependency_cycle: string;
        };
      };
      params: {
        toggle: string;
        empty: string;
        add: string;
        addCta: string;
        required: string;
        types: {
          date: string;
          int: string;
          string: string;
        };
        required_short: string;
        errors: {
          nameFormat: string;
          duplicate: string;
        };
      };
      gantt: {
        col: {
          unit: string;
          name: string;
        };
      };
      props: {
        id: string;
        name: string;
        unit: string;
        unitPlaceholder: string;
        kind: string;
        kindOptions: {
          task: string;
          milestone: string;
          external_milestone: string;
        };
        defaultPeople: string;
        effort: string;
        durationComputed: string;
        anchorOrDeps: string;
        noSelection: string;
        notes: string;
      };
      anchor: {
        byParam: string;
        byPredecessor: string;
        byPredecessorHint: string;
      };
      task: {
        defaultName: string;
      };
      link: {
        from: string;
        to: string;
        type: string;
        lagNumber: string;
        lagParam: string;
        delete: string;
        close: string;
        sectionTitle: string;
        addLink: string;
        noLinks: string;
        chooseSource: string;
        lagLabel: string;
        lagDays: string;
        edgeInspectorTitle: string;
        depType: {
          FS: { full: string; short: string };
          FF: { full: string; short: string };
          SS: { full: string; short: string };
          SF: { full: string; short: string };
        };
        depTypeHint: {
          FS: string;
          FF: string;
          SS: string;
          SF: string;
        };
      };
      deleteConfirm: {
        title: string;
        taskBody: string;
        linkBody: string;
        parameterBody: string;
        tasksBody: string;
      };
      discardDialog: {
        title: string;
        body: string;
        submit: string;
      };
      toasts: {
        saved: string;
        promoted: string;
        discarded: string;
      };
    };
    layout: {
      agentStub: {
        aria: string;
        title: string;
        body: string;
      };
      skeletonNote: string;
      bellAriaLabel: string;
      bellTitle_one: string;
      bellTitle_few: string;
      bellTitle_many: string;
      bellTitle_other: string;
      bellEmpty: string;
      bellSeeAll: string;
      userMenu: {
        settings: string;
        logout: string;
      };
    };
    role: {
      admin: string;
      viewer: string;
      office_staff: string;
      worker: string;
    };
    home: {
      title: string;
      subtitle: string;
      pocLink: string;
      widgets: {
        empty: string;
        portfolioOverview: {
          title: string;
          activeBig: string;
          rows: {
            in_progress: string;
            planned: string;
            completed: string;
          };
        };
        loadSummary: {
          title: string;
          subtitle: string;
          rowFmt: string;
          empty: string;
        };
        recentChanges: {
          title: string;
          empty: string;
        };
        pendingApprovals: {
          title: string;
          empty: string;
          expires: string;
        };
        topRisks: {
          title: string;
          empty: string;
          severity: {
            critical: string;
            high: string;
            medium: string;
            low: string;
          };
          type: {
            overdue_task: string;
            approaching_deadline: string;
            resource_overload: string;
            dangling_dependency: string;
            critical_path_slippage: string;
          };
        };
      };
    };
    locale: {
      label: string;
      ru: string;
      en: string;
    };
    login: {
      title: string;
      email: string;
      password: string;
      submit: string;
      submitting: string;
      invalidEmail: string;
      passwordRequired: string;
      invalidCredentials: string;
      networkError: string;
      workerMode: {
        switchTo: string;
        switchBack: string;
        divider: string;
      };
    };
    settings: {
      title: string;
      changePasswordLink: string;
      language: string;
    };
    projects: {
      title: string;
      subtitle: string;
      breadcrumb: {
        portfolio: string;
        projects: string;
      };
      counterUnit: string;
      newCta: string;
      empty: string;
      searchAria: string;
      searchPlaceholder: string;
      status: string;
      atRisk: string;
      showArchived: string;
      archivedBadge: string;
      overdueBadge_one: string;
      overdueBadge_few: string;
      overdueBadge_many: string;
      overdueBadge_other: string;
      fromTemplate: string;
      fromTemplateShort: string;
      prev: string;
      next: string;
      pageIndicator: string;
      pageRange: string;
      dateRange: string;
      noManager: string;
      statusValues: {
        all: string;
        planned: string;
        in_progress: string;
        on_hold: string;
        completed: string;
        cancelled: string;
        at_risk: string;
      };
      columns: {
        code: string;
        name: string;
        customer: string;
        status: string;
        manager: string;
        dates: string;
        progress: string;
        plannedStart: string;
        plannedEnd: string;
      };
      tabs: {
        params: string;
        tasks: string;
        gantt: string;
        risks: string;
        history: string;
      };
      detail: {
        notes: string;
        stats: {
          progress: string;
          tasks: string;
          daysToEnd: string;
        };
        workdays_one: string;
        workdays_few: string;
        workdays_many: string;
        workdays_other: string;
      };
      params: {
        edit: string;
        saved: string;
        archive: string;
        archiveConfirmTitle: string;
        archiveConfirmBody: string;
        unarchive: string;
        archived: string;
        unarchived: string;
        delete: string;
        deleted: string;
        dangerTitle: string;
        deleteDescription: string;
        deleteConfirmTitle: string;
        deleteConfirmPrompt: string;
        deleteConfirmAria: string;
        deleteHasTimesheetHistory: string;
        deleteBlocked: string;
        close: string;
        closeConfirmTitle: string;
        closeConfirmBody: string;
        closeConfirmAction: string;
        closed: string;
        discardTitle: string;
        discardBody: string;
        discardAction: string;
        metricsEmpty: string;
        dirtyClean: string;
        dirtyPending: string;
        sections: {
          identification: string;
          dates: string;
          responsible: string;
          equipment: string;
          notes: string;
        };
        fields: {
          code: string;
          status: string;
          name: string;
          customer: string;
          plannedStart: string;
          plannedEnd: string;
          actualEnd: string;
          manager: string;
          managerPlaceholder: string;
          notes: string;
        };
      };
      equipment: {
        sectionLegend: string;
        typeLabel: string;
        typePlaceholder: string;
        typeClear: string;
        quantityLabel: string;
        loading: string;
        error: string;
        emptyElements: string;
        requiredTitle: string;
        requiredLockHint: string;
        selectedOptionsTitle: string;
        optionalTitle: string;
        yes: string;
        no: string;
        optionAria: string;
        optionUndecidedHint: string;
        optionUndecidedError: string;
        noElementHint: string;
        saveElementsFailed: string;
        metrics: {
          title: string;
          orphanGroup: string;
          loading: string;
          error: string;
          choicePlaceholder: string;
        };
      };
      risks: {
        empty: string;
        includeResolved: string;
        hideResolved: string;
        resolvedAt: string;
      };
      history: {
        empty: string;
      };
      gantt: {
        empty: string;
        zoom: string;
        today: string;
        zooms: {
          day: string;
          week: string;
          month: string;
          quarter: string;
        };
      };
      new: {
        title: string;
        subtitle: string;
        backToList: string;
        back: string;
        create: string;
        creating: string;
        applied: string;
        noTemplates: string;
        parametersLegend: string;
        parametersCount_one: string;
        parametersCount_few: string;
        parametersCount_many: string;
        parametersCount_other: string;
        steps: {
          template: string;
          params: string;
        };
        fields: {
          code: string;
          projectName: string;
          customerName: string;
          start: string;
          end: string;
          calendar: string;
          manager: string;
          managerPlaceholder: string;
        };
        errors: {
          required: string;
          dateFormat: string;
          integer: string;
          codeRequired: string;
          codeConflict: string;
          projectNameRequired: string;
          startRequired: string;
          endRequired: string;
          endBeforeStart: string;
          positiveInteger: string;
          calendarRequired: string;
          managerRequired: string;
          createFailed: string;
          forbidden: string;
        };
      };
      tasks: {
        empty: string;
        criticalPath: string;
        criticalPathShort: string;
        pin: string;
        unpin: string;
        edit: string;
        columns: {
          name: string;
          unit: string;
          plannedStart: string;
          plannedEnd: string;
          progress: string;
          actions: string;
        };
        statuses: {
          planned: string;
          in_progress: string;
          blocked: string;
          completed: string;
          cancelled: string;
        };
        statusBadges: {
          inProgress: string;
        };
        filters: {
          unit: string;
          allUnits: string;
          criticalOnly: string;
        };
        createCta: string;
        overtime: {
          title: string;
          openAria: string;
          range: string;
          from: string;
          to: string;
          hoursPerPerson: string;
          hoursHint: string;
          invalidRange: string;
          previewTitle: string;
          previewDays: string;
          previewHours: string;
          previewNote: string;
          failed: string;
          picks: {
            today: string;
            this_week: string;
            next_week: string;
            rest_of_month: string;
          };
        };
        modal: {
          title: string;
          save: string;
          saving: string;
          simulate: string;
          simulating: string;
          applyDirect: string;
          applyDirectTooltip: string;
          applying: string;
          simulateNeedsDate: string;
          simulateFailed: string;
          applyOk: string;
          applyFailed: string;
          conflict: string;
          noChanges: string;
          reasonRequired: string;
          reasonHint: string;
          pinned: {
            label: string;
            tooltip: string;
            indicator: string;
          };
          fields: {
            name: string;
            unit: string;
            unitPlaceholder: string;
            plannedStart: string;
            plannedEnd: string;
            durationDays: string;
            effortHours: string;
            defaultPeople: string;
            progressPct: string;
            status: string;
            notes: string;
            reason: string;
          };
        };
      };
    };
    units: {
      title: string;
      tabs: {
        structure: string;
      };
      empty: string;
      newCta: string;
      columns: {
        code: string;
        name: string;
        alias: string;
        capacityToday: string;
        sortOrder: string;
        status: string;
        lead: string;
        employees: string;
      };
      fields: {
        code: string;
        name: string;
        namePlaceholder: string;
        alias: string;
        aliasPlaceholder: string;
        capacityToday: string;
        subtreeCapacityToday: string;
        manHours: string;
        sortOrder: string;
        capacityWarningThreshold: string;
        capacityWarningThresholdHint: string;
        lead: string;
        leadManager: string;
        leadEmpty: string;
        leadClear: string;
        parent: string;
        parentRoot: string;
        parentClear: string;
      };
      tree: {
        expand: string;
        collapse: string;
        addChild: string;
        rename: string;
        move: string;
        delete: string;
        searchAria: string;
        searchPlaceholder: string;
        youLead: string;
        youDeputize: string;
        employeeCount_one: string;
        employeeCount_few: string;
        employeeCount_many: string;
        employeeCount_other: string;
      };
      move: {
        title: string;
        targetLabel: string;
        targetPlaceholder: string;
        submit: string;
        moved: string;
        failed: string;
      };
      delete: {
        title: string;
        confirm: string;
        childrenNote_one: string;
        childrenNote_other: string;
        childrenNoteRoot_one: string;
        childrenNoteRoot_other: string;
        submit: string;
        deleted: string;
        failed: string;
        blockedTitle: string;
        // Russian carries `_few`/`_many`; English supplies only `_one`/`_other`.
        blockedTasks_one: string;
        blockedTasks_few?: string;
        blockedTasks_many?: string;
        blockedTasks_other?: string;
        blockedMembers_one: string;
        blockedMembers_few?: string;
        blockedMembers_many?: string;
        blockedMembers_other?: string;
        blockedHint: string;
      };
      create: { title: string; submit: string };
      edit: { title: string; submit: string };
      params: {
        title: string;
        name: string;
        shortAlias: string;
        sortOrder: string;
        threshold: string;
        lead: string;
        leadPlaceholder: string;
        noLead: string;
        dirty: string;
        clean: string;
        invalid: string;
        discardTitle: string;
        discardBody: string;
        discardAction: string;
      };
      detail: {
        back: string;
        edit: string;
        tabs: { employees: string; availability: string };
        includeSubtree: string;
        previousMonth: string;
        nextMonth: string;
        currentMonth: string;
        horizonLabel: string;
        horizon_one: string;
        horizon_few?: string;
        horizon_many?: string;
        horizon_other?: string;
        loadingUnit: string;
        errorUnit: string;
        loadingPeople: string;
        errorPeople: string;
        emptyPeople: string;
        loadingPlanning: string;
        errorPlanning: string;
        emptyPlanning: string;
        capacityTitle: string;
        capacitySubtitle: string;
        capacityHours: string;
        nominalHours: string;
        peakLabel: string;
        empty: string;
        legend: string;
        peopleTitle: string;
        viewList: string;
        viewPeople: string;
        scopeOwn: string;
        scopeSubtree: string;
        horizonMonth: string;
        horizonQuarter: string;
        horizonYear: string;
      };
      deputies: {
        title: string;
        empty: string;
        permanent: string;
        until: string;
        userLabel: string;
        userPlaceholder: string;
        untilLabel: string;
        untilHint: string;
        assign: string;
        remove: string;
        removeConfirmTitle: string;
        removeConfirmBody: string;
        assigned: string;
        removed: string;
        assignFailed: string;
        removeFailed: string;
        userRequired: string;
        untilFuture: string;
      };
      approvalMode: {
        title: string;
        daily: string;
        weekly: string;
        managedByAdmin: string;
        hint: string;
        failed: string;
      };
      toast: {
        created: string;
        saved: string;
        createFailed: string;
        saveFailed: string;
      };
    };
    availability: {
      gridLabel: string;
      employeeColumn: string;
      capacity: string;
      teamMemberCount_one: string;
      teamMemberCount_few: string;
      teamMemberCount_many: string;
      teamMemberCount_other: string;
      allowedAbsenceCount_one: string;
      allowedAbsenceCount_few: string;
      allowedAbsenceCount_many: string;
      allowedAbsenceCount_other: string;
      warningAbsenceCount: string;
      anyAbsenceWarning: string;
      previousMonth: string;
      nextMonth: string;
      currentMonth: string;
      horizonLabel: string;
      horizon_one: string;
      horizon_few: string;
      horizon_many: string;
      horizon_other: string;
      week: string;
      weekCompact: string;
      today: string;
      dayOff: string;
      capacityValue: string;
      tooltip: string;
      absenceIntervalLabel: string;
      absenceReason: string;
      absenceHours: string;
      eventTypeReason: string;
      eventComment: string;
      durationDays_one: string;
      durationDays_few: string;
      durationDays_many: string;
      durationDays_other: string;
      durationHours: string;
      loadError: string;
      peopleNotFound: string;
      inactivePerson: string;
      subtreeCapacityOverview: string;
      editSchedule: string;
      filters: {
        allUnits: string;
        unitSearch: string;
        unitsEmpty: string;
        unitClear: string;
        searchAria: string;
        searchPlaceholder: string;
        eventTypes: string;
        eventTypesSearch: string;
        eventTypesEmpty: string;
      };
      legend: string;
      legendShow: string;
      legendHide: string;
      critical: string;
      absence: {
        vacation: string;
        unpaid_leave: string;
        sick: string;
        no_show: string;
        day_off: string;
        part_time: string;
        overtime: string;
      };
      empty: string;
      kind: {
        vacation: string;
        unpaid_leave: string;
        sick: string;
        no_show: string;
        day_off: string;
        part_time: string;
        overtime: string;
      };
    };
    people: {
      back: string;
      backUnits: string;
      notFound: string;
      scheduleTitle: string;
      calendarTitle: string;
      prevPeriod: string;
      nextPeriod: string;
      today: string;
      records: string;
      recordsEmpty: string;
      showPast: string;
      addAbsence: string;
      addOvertime: string;
      profileTitle: string;
      profileStatusActive: string;
      profileStatusInactive: string;
      profileDirty: string;
      profileClean: string;
      profileDiscardTitle: string;
      profileDiscardBody: string;
      profileDiscardAction: string;
      workTypesTitle: string;
      workTypesInactive: string;
      workTypesLockedHint: string;
      workTypesAdhocTitle: string;
      workTypesAdhocEmpty: string;
      workTypesPicker: string;
      workTypesSearch: string;
      workTypesSaveFailed: string;
      hours: string;
      payableShort: string;
      project: string;
      delete: string;
      deleteConfirm: string;
      deleteConfirmBody: string;
      leadership: {
        title: string;
        lead: string;
        deputy: string;
        until: string;
      };
      fields: {
        name: string;
        position: string;
        unit: string;
        calendar: string;
        calendarInherited: string;
        lineManager: string;
        yes: string;
        no: string;
        none: string;
      };
      absenceForm: {
        title: string;
        editTitle: string;
        desc: string;
        kind: string;
        kindVacation: string;
        kindUnpaidLeave: string;
        kindSick: string;
        kindNoShow: string;
        kindDayOff: string;
        kindPartTime: string;
        dateFrom: string;
        dateTo: string;
        hoursOff: string;
        hoursOffHint: string;
        reason: string;
        submit: string;
      };
      overtimeForm: {
        title: string;
        editTitle: string;
        desc: string;
        kind: string;
        project: string;
        projectPlaceholder: string;
        dateFrom: string;
        dateTo: string;
        hours: string;
        payable: string;
        reason: string;
        submit: string;
      };
      errors: {
        required: string;
        dateOrder: string;
        projectRequired: string;
        hoursPositive: string;
        hoursRange: string;
      };
      toast: {
        added: string;
        deleted: string;
        addFailed: string;
        deleteFailed: string;
      };
    };
    load: {
      title: string;
      unit: string;
      unitPlaceholder: string;
      from: string;
      to: string;
      resetRange: string;
      capacity: string;
      allocated: string;
      empty: string;
      overloadDays_one: string;
      overloadDays_few: string;
      overloadDays_many: string;
      overloadDays_other: string;
      drilldown: {
        title: string;
        subtitle: string;
        none: string;
        empty: string;
        project: string;
        people: string;
        hoursPerPerson: string;
        tasks: string;
        overtime: string;
      };
    };
    portfolio: {
      title: string;
      empty: string;
      projectsCount_one: string;
      projectsCount_few: string;
      projectsCount_many: string;
      projectsCount_other: string;
      unitsFilter: string;
      clearUnits: string;
      legendMore: string;
      taskColumn: string;
      searchProjects: string;
      projectsFilter: string;
      clearProjects: string;
      clearStatus: string;
      statusFilter: string;
      tasksFilter: string;
      searchTasks: string;
      clearTasks: string;
    };
    simulation: {
      toast: {
        overtime: string;
        taskMove: string;
      };
      help: {
        trigger: string;
        title: string;
        whatIs: string;
        whenNeeded: string;
        whenNotNeeded: string;
        whereLives: string;
      };
    };
    approvals: {
      title: string;
      empty: string;
      count_one: string;
      count_few: string;
      count_many: string;
      count_other: string;
      expiresIn: string;
      expired: string;
      timeHM: string;
      timeM: string;
      projectEndChange: string;
      affectedTasks: string;
      overloads: string;
      overloadsMore: string;
      project: string;
      kindLabel: string;
      apply: string;
      reject: string;
      openGantt: string;
      kind: {
        task_move: string;
        task_status_change: string;
        apply_template: string;
        create_project_from_template: string;
        add_task: string;
        remove_task: string;
        set_allocation: string;
        set_task_overtime: string;
        set_company_calendar_override: string;
      };
      autoSummary: {
        task_move_one: string;
        task_move_few: string;
        task_move_many: string;
        task_move_other: string;
        task_status_change: string;
        apply_template: string;
        create_project_from_template: string;
        add_task: string;
        remove_task: string;
        set_allocation: string;
        set_task_overtime: string;
        set_company_calendar_override: string;
      };
      userCommentLabel: string;
      dialog: {
        applyTitle: string;
        rejectTitle: string;
        applyConfirm: string;
        rejectConfirm: string;
        reasonLabel: string;
        reasonPlaceholder: string;
      };
      toast: {
        applied_one: string;
        applied_few: string;
        applied_many: string;
        applied_other: string;
        rejected: string;
        applyFailed: string;
        rejectFailed: string;
        conflict: string;
        expired: string;
      };
      detail: {
        title: string;
        back: string;
        expires: string;
        modeLabel: string;
        noProject: string;
        modes: {
          baseline: string;
          simulation: string;
          both: string;
        };
      };
    };
    risks: {
      title: string;
      empty: string;
      countTotal_one: string;
      countTotal_few: string;
      countTotal_many: string;
      countTotal_other: string;
      filters: {
        severity: string;
        type: string;
        project: string;
        all: string;
        noProject: string;
        unresolvedOnly: string;
        includeResolved: string;
        reset: string;
        clear: string;
      };
      columns: {
        severity: string;
        type: string;
        description: string;
        project: string;
        detectedAt: string;
        status: string;
      };
      severity: {
        critical: string;
        high: string;
        medium: string;
        low: string;
      };
      type: {
        overdue_task: string;
        approaching_deadline: string;
        resource_overload: string;
        dangling_dependency: string;
        critical_path_slippage: string;
      };
      status: {
        active: string;
        resolved: string;
      };
      resolvedAt: string;
      noProject: string;
      noProjectChip: string;
      help: {
        aria: string;
        title: string;
        intro: string;
        detectors: {
          overdue_task: string;
          approaching_deadline: string;
          resource_overload: string;
          dangling_dependency: string;
        };
        refresh: string;
        usage: string;
      };
    };
    audit: {
      title: string;
      empty: string;
      loadMore: string;
      loading: string;
      countLoaded_one: string;
      countLoaded_few: string;
      countLoaded_many: string;
      countLoaded_other: string;
      tabs: {
        plan: string;
      };
      filters: {
        project: string;
        actor: string;
        actorPlaceholder: string;
        kind: string;
        dateFrom: string;
        dateTo: string;
        all: string;
        noProject: string;
        reset: string;
      };
      kind: {
        task_move: string;
        task_status_change: string;
        apply_template: string;
        add_task: string;
        remove_task: string;
        set_allocation: string;
        set_task_overtime: string;
        set_company_calendar_override: string;
        create_project_from_template: string;
        manual_edit: string;
        auth: {
          login: {
            success: string;
            failed: string;
          };
          account: {
            locked: string;
          };
          pin: {
            locked: string;
          };
          password: {
            changed: string;
          };
        };
        admin: {
          user: {
            create: string;
            patch: string;
            deactivate: string;
            reset_pin: string;
            work_types: string;
          };
        };
      };
      securityPreset: string;
      openGantt: string;
      presentation: {
        unknownEvent: string;
        unknownObject: string;
        unknownActor: string;
        systemActor: string;
        showDetails: string;
        hideDetails: string;
        changeCount_one: string;
        changeCount_few: string;
        changeCount_many: string;
        changeCount_other: string;
        reason: string;
        columns: {
          details: string;
          when: string;
          actor: string;
          event: string;
          object: string;
          changes: string;
          field: string;
          before: string;
          after: string;
        };
        operation: {
          create: string;
          update: string;
          delete: string;
        };
      };
      timesheet: {
        title: string;
        subtitle: string;
        forbidden: string;
        empty: string;
        loadMore: string;
        loading: string;
        filters: {
          worker: string;
          project: string;
          workType: string;
          dateFrom: string;
          dateTo: string;
          all: string;
          showDeleted: string;
          needsAttention: string;
          needsAttentionHelp: {
            title: string;
            items: readonly [string, string, string, string, string];
          };
          adminBackfillOnly: string;
          reset: string;
        };
        columns: {
          entryId: string;
          when: string;
          worker: string;
          workDate: string;
          project: string;
          work: string;
          hours: string;
          declared: string;
          status: string;
          timeToSign: string;
          source: string;
          actions: string;
        };
        openInBackfill: string;
        unknownProject: string;
        noProject: string;
        skippedProject: string;
        unknownWorkType: string;
        declaredOffNorm: string;
        reworkUnlabeled: string;
        reworkUnlabeledHint: string;
        replaced: string;
        deleted: string;
        adminBackfill: string;
        adminBackfillUnknown: string;
        replacedBy: string;
        replacedTooltip: string;
        replacedTooltipNoRef: string;
        userDeletedTooltip: string;
        userDeletedAt: string;
        adminDeletedTooltip: string;
        adminDeletedAt: string;
        deletedBy: string;
        signedAt: string;
        approvedAt: string;
        timeToSign: string;
        status: {
          draft: string;
          signed: string;
          approved: string;
        };
        hoursSuffix: string;
        tab: string;
        loadError: string;
      };
    };
    calendar: {
      title: string;
      subtitle: string;
      calendarSelect: string;
      defaultName: string;
      standardWeek: string;
      standardWeekHours: string;
      standardWeekOff: string;
      weekDayShort: {
        mon: string;
        tue: string;
        wed: string;
        thu: string;
        fri: string;
        sat: string;
        sun: string;
      };
      weekDayFull: {
        mon: string;
        tue: string;
        wed: string;
        thu: string;
        fri: string;
        sat: string;
        sun: string;
      };
      empty: string;
      newCta: string;
      forbidden: string;
      columns: {
        dateFrom: string;
        dateTo: string;
        hours: string;
        reason: string;
        createdBy: string;
        createdAt: string;
        actions: string;
      };
      fields: {
        dateFrom: string;
        dateTo: string;
        hours: string;
        reason: string;
        editReason: string;
      };
      hoursHint: {
        zero: string;
        short: string;
        normal: string;
        overtime: string;
      };
      create: { title: string; submit: string };
      edit: { title: string; submit: string };
      delete: {
        confirmTitle: string;
        confirmBody: string;
        confirm: string;
        cancel: string;
      };
      errors: {
        required: string;
        dateOrder: string;
        hoursRange: string;
      };
      toast: {
        created: string;
        saved: string;
        deleted: string;
        createFailed: string;
        saveFailed: string;
        deleteFailed: string;
      };
    };
    admin: {
      catalogs: {
        title: string;
        subtitle: string;
        tabs: {
          workTypes: string;
          equipmentTypes: string;
          assemblyElements: string;
          personEventTypes: string;
          positions: string;
          calendar: string;
        };
      };
      personEventTypes: {
        newCta: string;
        empty: string;
        noResults: string;
        searchPlaceholder: string;
        searchAria: string;
        selectPrompt: string;
        createTitle: string;
        editTitle: string;
        create: string;
        save: string;
        delete: string;
        dragHandle: string;
        lockReason: string;
        columns: {
          name: string;
          group: string;
          abbreviation: string;
          code: string;
          status: string;
        };
        fields: {
          name: string;
          group: string;
          color: string;
          abbreviation: string;
          code: string;
        };
        groups: { absence: string; overtime: string };
        colors: {
          gray: string;
          dark: string;
          blue: string;
          yellow: string;
          green: string;
          red: string;
        };
        deleteDialog: { title: string; body: string };
        errors: { nameRequired: string };
        toast: { saved: string; saveFailed: string; reorderFailed: string };
      };
      positions: {
        newCta: string;
        empty: string;
        noResults: string;
        searchPlaceholder: string;
        searchAria: string;
        selectPrompt: string;
        deleteAction: string;
        cancel: string;
        create: string;
        row: {
          dragHandle: string;
          editHint: string;
        };
        fields: {
          name: string;
          namePlaceholder: string;
        };
        workTypes: {
          paneLabel: string;
          listLabel: string;
          readOnlyHint: string;
        };
        createDialog: {
          title: string;
        };
        deleteDialog: {
          title: string;
          body: string;
          submit: string;
        };
        deleteBlockedDialog: {
          title: string;
          body: string;
          ok: string;
        };
        errors: {
          nameRequired: string;
        };
        toast: {
          created: string;
          updated: string;
          deleted: string;
          createFailed: string;
          updateFailed: string;
          deleteFailed: string;
          reorderFailed: string;
          workTypesFailed: string;
        };
      };
      equipmentTypes: {
        newCta: string;
        empty: string;
        noResults: string;
        noCategory: string;
        searchPlaceholder: string;
        searchAria: string;
        selectPrompt: string;
        status: {
          active: string;
          inactive: string;
        };
        row: {
          dragHandle: string;
          editHint: string;
        };
        editAction: string;
        deleteAction: string;
        cancel: string;
        save: string;
        create: string;
        fields: {
          name: string;
          namePlaceholder: string;
          category: string;
          categoryPlaceholder: string;
          categoryHint: string;
        };
        createDialog: {
          title: string;
        };
        editDialog: {
          title: string;
        };
        renameDialog: {
          title: string;
        };
        deleteDialog: {
          title: string;
          body: string;
          submit: string;
        };
        deleteBlockedDialog: {
          title: string;
          body: string;
          ok: string;
        };
        errors: {
          nameRequired: string;
        };
        elements: {
          listLabel: string;
          searchPlaceholder: string;
          searchAria: string;
          empty: string;
          noResults: string;
          noComposition: string;
          hideAbsent: string;
          searchRevealNotice: string;
          addCta: string;
          partialLinkFailure: string;
          retryLink: string;
          addDialogTitle: string;
          addNameLabel: string;
          addNamePlaceholder: string;
          statusAria: string;
          unlinkConfirmTitle: string;
          unlinkConfirmBody: string;
          status: {
            none: string;
            required: string;
            optional: string;
          };
        };
        toast: {
          created: string;
          updated: string;
          deleted: string;
          statusUpdated: string;
          elementCreated: string;
          createFailed: string;
          updateFailed: string;
          deleteFailed: string;
          reorderFailed: string;
          statusFailed: string;
        };
      };
      assemblyElements: {
        newCta: string;
        empty: string;
        noResults: string;
        noCategory: string;
        searchPlaceholder: string;
        searchAria: string;
        selectPrompt: string;
        status: {
          active: string;
          inactive: string;
        };
        row: {
          dragHandle: string;
          editHint: string;
        };
        deleteAction: string;
        editAction: string;
        cancel: string;
        save: string;
        create: string;
        fields: {
          name: string;
          category: string;
          categoryPlaceholder: string;
          categoryHint: string;
        };
        createDialog: {
          title: string;
        };
        editDialog: {
          title: string;
        };
        deleteDialog: {
          title: string;
          body: string;
          submit: string;
        };
        deleteBlockedDialog: {
          title: string;
          body: string;
          ok: string;
        };
        errors: {
          nameRequired: string;
        };
        metrics: {
          listLabel: string;
          empty: string;
          addCta: string;
          deleteAction: string;
          optionsCta: string;
          type: {
            number: string;
            choice: string;
            text: string;
          };
          fields: {
            name: string;
            type: string;
            typePlaceholder: string;
            typeHint: string;
          };
          createDialog: {
            title: string;
          };
          deleteDialog: {
            title: string;
            body: string;
            submit: string;
          };
          optionsDialog: {
            title: string;
            empty: string;
            addCta: string;
            valuePlaceholder: string;
            removeAria: string;
            removeConfirmTitle: string;
            removeConfirmBody: string;
            emptyValue: string;
          };
        };
        toast: {
          created: string;
          updated: string;
          deleted: string;
          metricCreated: string;
          metricDeleted: string;
          optionsUpdated: string;
          createFailed: string;
          updateFailed: string;
          deleteFailed: string;
          reorderFailed: string;
          optionsFailed: string;
        };
      };
      users: {
        title: string;
        subtitle: string;
        subtitleLead: string;
        empty: string;
        newCta: string;
        statusActive: string;
        statusInactive: string;
        tracksTime: {
          on: string;
        };
        columns: {
          person: string;
          role: string;
          unit: string;
          status: string;
          lastLogin: string;
          actions: string;
          position: string;
        };
        fields: {
          last_name: string;
          first_name: string;
          patronymic: string;
          role: string;
          unit: string;
          email: string;
          tracksTime: string;
          projectManager: string;
          tabNumber: string;
          tabNumberOptional: string;
          tabNumberPlaceholder: string;
          initialPin: string;
          position: string;
          positionEmptyValue: string;
          positionSearchPlaceholder: string;
          positionNotFound: string;
          positionClear: string;
          positionCreate: string;
          positionHint: string;
          unitPlaceholder: string;
          unitLockedHint: string;
          schedule: string;
          scheduleDefault: string;
          scheduleHint: string;
          hireDate: string;
          terminationDate: string;
        };
        searchAria: string;
        searchPlaceholder: string;
        unitFilter: {
          placeholder: string;
          searchPlaceholder: string;
          empty: string;
          clear: string;
        };
        positionFilter: {
          placeholder: string;
          searchPlaceholder: string;
          empty: string;
          clear: string;
        };
        filtersReset: string;
        activity: {
          label: string;
          active: string;
          inactive: string;
          all: string;
        };
        groupSwitcher: {
          label: string;
          office: string;
          worker: string;
        };
        actions: {
          resetPin: string;
          resetPassword: string;
          edit: string;
          reactivate: string;
        };
        actionReasons: {
          self_deactivation: string;
          last_active_admin: string;
          inactive_account: string;
          active_account: string;
          outside_management_scope: string;
          protected_role: string;
          wrong_auth_method: string;
        };
        create: { title: string; submit: string };
        edit: { title: string; submit: string };
        deactivate: string;
        deactivateDialog: {
          title: string;
          body: string;
        };
        unitNone: string;
        tempPasswordDialog: {
          title: string;
          subtitle: string;
          copy: string;
          copied: string;
          done: string;
        };
        reactivateDialog: {
          title: string;
          body: string;
        };
        resetPinConfirm: {
          title: string;
          body: string;
          submit: string;
        };
        resetPinDialog: {
          title: string;
          subtitle: string;
          warning: string;
          copy: string;
          copied: string;
          done: string;
        };
        resetPasswordConfirm: {
          title: string;
          body: string;
          submit: string;
        };
        resetPasswordDialog: {
          title: string;
          subtitle: string;
          warning: string;
          copy: string;
          copied: string;
          done: string;
        };
        errors: {
          required: string;
          emailFormat: string;
          unitRequired: string;
          tabFormat: string;
          pinFormat: string;
          employmentDateOrder: string;
          projectManagerRole: string;
        };
        toast: {
          created: string;
          workerCreated: string;
          positionCreateFailed: string;
          saved: string;
          deactivated: string;
          reactivated: string;
          createFailed: string;
          saveFailed: string;
          deactivateFailed: string;
          reactivateFailed: string;
          resetPinFailed: string;
          resetPasswordFailed: string;
        };
        guards: {
          selfDeactivate: string;
          selfRoleAdmin: string;
          lastAdmin: string;
          lastAdminRole: string;
        };
      };
      checklist: {
        title: string;
        paneAria: string;
        pickWorkType: string;
        empty: string;
        addCta: string;
        createDialogTitle: string;
        titleLabel: string;
        titleRequired: string;
        create: string;
        editHint: string;
        dragAria: string;
        deleteAria: string;
        activeF: string;
        inactiveF: string;
        deleteConfirmTitle: string;
        deleteConfirmBody: string;
        toast: {
          created: string;
          createFailed: string;
          updated: string;
          updateFailed: string;
          deleted: string;
        };
        condition: {
          none: string;
          addCta: string;
          equipment: string;
          element: string;
          anyEquipment: string;
          anyElement: string;
          saveCta: string;
          clear: string;
          notFound: string;
          removeAria: string;
          removeConfirmTitle: string;
          removeConfirmBody: string;
          hint: string;
        };
      };
      workTypes: {
        title: string;
        subtitle: string;
        newCta: string;
        empty: string;
        searchPlaceholder: string;
        searchAria: string;
        noResults: { active: string; all: string };
        activity: { label: string; active: string; all: string };
        noCategory: string;
        positions: {
          title: string;
          more: string;
          edit: string;
          search: string;
          searchEmpty: string;
          empty: string;
          active: string;
          inactive: string;
          saveFailed: string;
        };
        selectPrompt: string;
        sortHint: string;
        listLabel: string;
        detailLabel: string;
        statusActive: string;
        statusInactive: string;
        active: string;
        status: { active: string; inactive: string };
        row: { dragHandle: string; editHint: string };
        moveUp: string;
        moveDown: string;
        rename: string;
        editAction: string;
        deleteAction: string;
        cancel: string;
        save: string;
        create: string;
        fields: {
          name: string;
          namePlaceholder: string;
          category: string;
          categoryPlaceholder: string;
          categoryHint: string;
        };
        createDialog: { title: string };
        editDialog: { title: string };
        renameDialog: { title: string };
        deleteDialog: { title: string; body: string; submit: string };
        deleteBlockedDialog: { title: string; body: string; ok: string };
        errors: {
          nameRequired: string;
          nameDuplicate: string;
        };
        toast: {
          created: string;
          updated: string;
          deleted: string;
          createFailed: string;
          updateFailed: string;
          deleteFailed: string;
          reorderFailed: string;
        };
      };
      backfill: {
        kicker: string;
        title: string;
        subtitle: string;
        forbidden: string;
        loadError: string;
        emptyHint: string;
        cancel: string;
        fields: {
          worker: string;
          workerPlaceholder: string;
          workersError: string;
          date: string;
          today: string;
        };
        status: { draft: string; signed: string; approved: string };
        entries: {
          empty: string;
          col: { project: string; workType: string; hours: string };
          delete: string;
          edit: string;
          deleted: string;
          deleteFailed: string;
          deleteConfirmTitle: string;
          deleteConfirmOk: string;
        };
        composer: {
          title: string;
          workType: string;
          workTypePlaceholder: string;
          workTypeFree: string;
          workTypeFreePlaceholder: string;
          project: string;
          projectSkip: string;
          hours: string;
          submit: string;
          created: string;
          createFailed: string;
        };
        project: {
          placeholder: string;
          searchPlaceholder: string;
          hint: string;
          empty: string;
          unknownTag: string;
          recordAsIs: string;
          clearAria: string;
          confirmTitle: string;
          confirmBody: string;
          confirmCancel: string;
          confirmOk: string;
        };
        sign: {
          sumLabel: string;
          declaredLabel: string;
          cta: string;
          confirmTitle: string;
          confirmBody: string;
          confirmOk: string;
          toast: string;
          failed: string;
        };
      };
    };
    field: {
      shell: {
        logout: string;
        context: { timesheet: string; sign: string };
        placeholder: { timesheet: string; sign: string };
      };
      login: {
        title: string;
        subtitle: string;
        backToOffice: string;
        digitsAria: string;
        errors: {
          invalidCredentials: string;
          accountDisabled: string;
          networkError: string;
        };
      };
      logout: string;
      titles: { today: string; week: string; overdue: string };
      tabs: { today: string; week: string; overdue: string };
      empty: { today: string; week: string; overdue: string };
      offline: {
        banner: string;
        toast: { savedLocally: string; dropped: string };
      };
      card: { dates: string; status: string; progress: string };
      status: {
        planned: string;
        in_progress: string;
        completed: string;
        blocked: string;
        cancelled: string;
      };
      actions: { start: string; finish: string; comment: string };
      comment: { title: string; placeholder: string; offlineHint: string };
      toast: {
        started: string;
        finished: string;
        commentSaved: string;
        actionFailed: string;
      };
      pin: {
        title: string;
        context: { login: string; sign: string };
        submitting: string;
        dotsAria: string;
        error: { attempt: string; invalid: string };
        lockout: { message: string; close: string };
      };
      main: {
        date: { today: string; yesterday: string; dayBefore: string; changeAria: string };
        backfill: {
          label: string;
          days_one: string;
          days_few: string;
          days_many: string;
          days_other: string;
        };
        dateSheet: { title: string };
        stat: {
          totalWorks: string;
          norm: string;
        };
        entries: {
          empty: string;
          editAria: string;
          deleteAria: string;
          deleteTitle: string;
          deleteBody: string;
          deleteOk: string;
          deleteCancel: string;
          deleteToastFailed: string;
          unknownProject: string;
          noProject: string;
        };
        emptyState: { title: string; subtitle: string; hint: string };
        trackingOff: { title: string; subtitle: string };
        addEntry: string;
        addMore: string;
        addMoreHint: string;
        total: string;
        sign: string;
        signDisabledHint: string;
        delete: { title: string; description: string; confirm: string; cancel: string };
        toast: { entryDeleted: string; entryDeleteFailed: string };
        error: { backfillWindow: string };
        readonly: { signed: string; approved: string; editHint: string; edit: string };
      };
      entryFlow: {
        stepCounter: string;
        editBadge: string;
        dockTitle: string;
        dockDescription: string;
        closeAria: string;
        cancel: string;
        continue: string;
        saving: string;
        submitCta: string;
        closeConfirmTitle: string;
        closeConfirmBody: string;
        closeConfirmCancel: string;
        closeConfirmOk: string;
        deleteAria: string;
        deleteTitle: string;
        deleteBody: string;
        deleteBodyNamed: string;
        deleteOk: string;
        pill: {
          workType: string;
          project: string;
          projectSkipped: string;
          element: string;
          elementSkipped: string;
          elementFallback: string;
          clearAria: string;
        };
        step1: {
          title: string;
          customCta: string;
          customLabel: string;
          customPlaceholder: string;
        };
        step2: {
          title: string;
          recentHint: string;
          manualCta: string;
          searchHint: string;
          emptyShort: string;
          recordAsIs: string;
          padAria: string;
          unknownProjectTitle: string;
          unknownProjectBody: string;
          unknownProjectCancel: string;
          unknownProjectOk: string;
          skipCta: string;
        };
        step3: {
          title: string;
          loading: string;
          empty: string;
          skipCta: string;
          skipEmptyCta: string;
        };
        step4: { title: string; hint: string; required: string };
        rework: {
          badge: string;
          bannerTitle: string;
          bannerBody: string;
          bannerBodyNoDate: string;
          noteLabel: string;
          notePlaceholder: string;
        };
        toast: {
          saveFailed: string;
          deleteFailed: string;
          conflict: string;
        };
      };
      sign: {
        loading: string;
        back: { aria: string };
        summary: { title: string; total: string; empty: string };
        declared: {
          title: string;
          edit: string;
        };
        tabelEdit: {
          title: string;
          calendarHint: string;
          overtimeBadge: string;
          overtimeBody: string;
          cancel: string;
          apply: string;
          confirmOvertime: string;
          stepperAria: string;
        };
        button: string;
        pinTitle: string;
        confirm: {
          title: string;
          body: string;
          submitting: string;
        };
        toast: {
          submitted: string;
          failed: string;
          alreadyApproved: string;
          backfillExceeded: string;
        };
      };
      tabel: {
        warning: {
          over: string;
          overApprovalNote: string;
          under: string;
        };
      };
    };
    changePassword: {
      title: string;
      loggedInAs: string;
      logout: string;
      cancel: string;
      current: string;
      next: string;
      confirm: string;
      submit: string;
      submitting: string;
      required: string;
      mismatch: string;
      invalidCurrent: string;
      networkError: string;
      policy: {
        heading: string;
        length: string;
        minClasses: string;
        lower: string;
        upper: string;
        digit: string;
        special: string;
        error: string;
      };
    };
    gantt: {
      criticalMarker: string;
      cpToggle: {
        label: string;
        ariaOn: string;
        ariaOff: string;
      };
      search: {
        empty: string;
        clear: string;
      };
      toolbar: {
        zoom: {
          day: string;
          week: string;
          month: string;
          quarter: string;
        };
        today: {
          label: string;
          lineToggle: string;
        };
        density: {
          compact: string;
          normal: string;
        };
        cp: {
          label: string;
          counter: string;
          days: string;
          progress: string;
        };
        search: {
          placeholder: string;
          ariaLabel: string;
        };
        download: {
          label: string;
          notReady: string;
        };
      };
      legend: {
        task: string;
        cp: string;
        milestone: string;
        dep: string;
        depCp: string;
        today: string;
        projectColor: string;
      };
      help: {
        aria: string;
        title: string;
      };
    };
  };
}
